/**
 * This file is auto-generated by Amplitude.
 * To update run 'ampli pull ed-frontend'
 *
 * Works with versions ^2.0.8 of @itly/sdk and @itly/plugin's
 * https://www.npmjs.com/search?q=%40itly
 */

/* tslint:disable */
/* eslint-disable */
import {
  ItlyBrowser,
  Options as OptionsBase,
  Event as EventBase,
  Plugin,
  Environment as EnvironmentBase,
  Properties as PropertiesBase,
  ValidationResponse as ValidationResponseBase,
  CallOptions as CallOptionsBase,
  PluginCallOptions as PluginCallOptionsBase,
} from '@itly/sdk';
import SchemaValidatorPlugin from '@itly/plugin-schema-validator';
import {
  SegmentPlugin,
  SegmentOptions,
  SegmentAliasOptions as SegmentAliasOptionsBase,
  SegmentIdentifyOptions as SegmentIdentifyOptionsBase,
  SegmentGroupOptions as SegmentGroupOptionsBase,
  SegmentPageOptions as SegmentPageOptionsBase,
  SegmentTrackOptions as SegmentTrackOptionsBase,
} from '@itly/plugin-segment';

export type Options = OptionsBase;
export type Environment = EnvironmentBase;
export type Event = EventBase;
export type Properties = PropertiesBase;
export type ValidationResponse = ValidationResponseBase;
export type CallOptions = CallOptionsBase;
export type PluginCallOptions = PluginCallOptionsBase;
export { Plugin, Validation, Loggers } from '@itly/sdk';
export type SegmentAliasOptions = SegmentAliasOptionsBase;
export type SegmentIdentifyOptions = SegmentIdentifyOptionsBase;
export type SegmentGroupOptions = SegmentGroupOptionsBase;
export type SegmentPageOptions = SegmentPageOptionsBase;
export type SegmentTrackOptions = SegmentTrackOptionsBase;

export interface AliasOptions extends CallOptions {
  segment?: SegmentAliasOptions;
}

export interface IdentifyOptions extends CallOptions {
  segment?: SegmentIdentifyOptions;
}

export interface GroupOptions extends CallOptions {
  segment?: SegmentGroupOptions;
}

export interface PageOptions extends CallOptions {
  segment?: SegmentPageOptions;
}

export interface TrackOptions extends CallOptions {
  segment?: SegmentTrackOptions;
}

export interface IdentifyProperties {
  application_id?: string;
  application_name?: string;
  /**
   * User App Version
   */
  appVersion?: string;
  /**
   * Hubspot Only
   */
  billing_plan?: string;
  company_size?: string;
  email?: string;
  firstname?: string;
  /**
   * IP Geolocation country
   */
  geolocation_country?: string;
  industry?: string;
  isTrial?: boolean;
  /**
   * User signup intent
   */
  iwantto?: string[];
  jobtitle?: string;
  /**
   * language of the user
   */
  language?: string;
  lastname?: string;
  lifecyclestage?: string;
  name?: string;
  phone?: string;
  region?: string;
  roles?: string[];
  /**
   * Hubspot Only
   */
  safety_culture_integration?: "Before" | "After";
  /**
   * Hubspot Only
   */
  safety_culture_sign_up?: boolean;
  /**
   * SC User ID when used in UXP
   */
  sc_user_id?: string;
  /**
   * Hubspot Only
   */
  sign_up_origin?: string;
  /**
   * Hubspot Only
   */
  signed_up_on_app?: boolean;
  vertical?: string;
}

export interface GroupProperties {
  "[Amplitude] Group ID"?: {
    [k: string]: unknown;
  };
  "[Amplitude] Group name"?: {
    [k: string]: unknown;
  };
  amplitudeType?: string;
  application_id?: string;
  application_name?: string;
  appName?: {
    [k: string]: unknown;
  };
  billing_plan?: string;
  /**
   * Self-Service / Enterprise / iAuditor / Educate-all
   */
  channel?: "Self-Service" | "Enterprise" | "iAuditor" | "Educate-all";
  company?: string;
  company_size?: string;
  context?: {
    [k: string]: unknown;
  };
  createdAt?: {
    [k: string]: unknown;
  };
  displayName?: {
    [k: string]: unknown;
  };
  email?: string;
  id?: {
    [k: string]: unknown;
  };
  isTrial?: boolean;
  name?: {
    [k: string]: unknown;
  };
  phone?: string;
  plan?: {
    [k: string]: unknown;
  };
  signup_creation_flow_cohort?: "A" | "B" | "control";
  vertical?: string;
  website?: string;
}

export interface PageProperties {
  appVersion?: string;
  /**
   * If the page loads an edapp domain or sc domain
   */
  is_edapp?: boolean;
  /**
   * Is loaded in an iframe
   */
  is_iframe?: boolean;
  /**
   * loaded a single lesson
   */
  lesson_only?: boolean;
  network?: string;
}

export interface AchievementsClickedProperties {
  title?: string;
}

export interface AddCoursesToPlaylistProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  course_ids: string[];
  /**
   * Playlist ID
   */
  playlist_id?: string;
  /**
   * Whether a playlist is "free form" or "sequential".
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Free, Sequential |
   */
  playlist_type?: "Free" | "Sequential";
}

export interface AdminFilterAppliedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | all, owned-or-shared |
   */
  access?: "all" | "owned-or-shared";
  date?: {
    [k: string]: unknown;
  };
  isGroupTrainingEnabled?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  locales?: string[];
  status?: string;
  universalAccess?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  usergroupIds?: string[];
}

export interface AICreateSlideAddedToLessonProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Questions, Text |
   */
  ai_slide_type: "Questions" | "Text";
}

export interface AIDocumentConvertedProperties {
  document_type?: string;
}

export interface AIGeneratedCourseProperties {
  billing_plan?: string;
  course_id: string;
  email?: string;
  file_extension?: string;
  file_name?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  file_size?: number;
  file_type?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | prompt, document |
   */
  input_type?: "prompt" | "document";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  number_of_images?: number;
  topic_input: string;
}

export interface AIGeneratedLessonProperties {
  billing_plan?: string;
  course_id: string;
  email?: string;
  topic_input: string;
}

export interface AINarrationVoiceAppliedProperties {
  language?: string;
  voice: string;
}

export interface AITextEditedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | rewrite, adjust_tone, reduce, extend |
   */
  action: "rewrite" | "adjust_tone" | "reduce" | "extend";
}

export interface AIOBActionClickedProperties {
  /**
   * AIOB Actions
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | add-section, expand-section, collapse-section, delete-section, expand-lesson-details, collapse-lesson-details, enable-code-view, disable-code-view, lesson-scorm-export, preview-custom-dimensions, skip-course-overview, hide-navigation, slide-selected, lesson-selected, slide-navigation-arrow, share-publicly, share-for-review, lesson-switcher, comment-tab, edit-tab, preview-tab, undo, redo, publish, language-picker, narration-added, navigate-edit, navigate-setup, navigate-publish |
   */
  action:
    | "add-section"
    | "expand-section"
    | "collapse-section"
    | "delete-section"
    | "expand-lesson-details"
    | "collapse-lesson-details"
    | "enable-code-view"
    | "disable-code-view"
    | "lesson-scorm-export"
    | "preview-custom-dimensions"
    | "skip-course-overview"
    | "hide-navigation"
    | "slide-selected"
    | "lesson-selected"
    | "slide-navigation-arrow"
    | "share-publicly"
    | "share-for-review"
    | "lesson-switcher"
    | "comment-tab"
    | "edit-tab"
    | "preview-tab"
    | "undo"
    | "redo"
    | "publish"
    | "language-picker"
    | "narration-added"
    | "navigate-edit"
    | "navigate-setup"
    | "navigate-publish";
  isLanguageOriginal?: boolean;
}

export interface AnalyticsFilterAppliedProperties {
  /**
   * Array of Filters Applied
   *
   * \["User Status", "Assigned Status"\]
   *
   * | Rule | Value |
   * |---|---|
   * | Min Items | 0 |
   * | Item Type | string |
   *
   * @minItems 0
   */
  viz_filters_applied?: string[];
  /**
   * Array of Filters with values e.g.
   *
   * \["User Status: Active", "User Status: Deactivated"\]
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  viz_filters_applied_value?: string[];
  /**
   * The internal analytics report name which is unique e.g. manager-dashboard-user-group-performance-direct-table
   */
  viz_name: string;
  /**
   * The display name of analytics report e.g. Course Completion by User
   */
  viz_title?: string;
}

export interface AssignedRolesToUserProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  roles_assigned: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | user-profile, create_user, csv, public_api |
   */
  update_location: "user-profile" | "create_user" | "csv" | "public_api";
  user_id: string;
}

export interface AssignedUserToGroupsProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  number_groups: number;
}

export interface AssignedUsersGroupsToCourseLocationProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Assign button, Publish modal |
   */
  course_user_group_assign_location: "Assign button" | "Publish modal";
  selection_modified: boolean;
}

export interface BannerCreatedProperties {
  auto_branding?: boolean;
  banner_type?: string;
  has_url?: boolean;
  uploaded_image?: boolean;
}

export interface BannerDeletedProperties {
  banner_id: string;
}

export interface BannerOpenedProperties {
  banner_id: string;
  is_course_deeplink?: boolean;
  url?: string;
}

export interface BannerUpdatedProperties {
  auto_branding?: boolean;
  banner_id: string;
  banner_type?: string;
  has_url?: boolean;
  uploaded_image?: boolean;
}

export interface BrainBoostAddCourseProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  course_count: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  course_ids: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  slide_count: number;
}

export interface BrainBoostEditCourseProperties {
  course_id: string;
  is_new: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  slides_count: number;
}

export interface BrainBoostEditSettingsProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  slides_per_session: number;
}

export interface BrainBoostEndSessionProperties {
  /**
   * The number of slides answered correctly in the session
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  correct: number;
  /**
   * The number of slides answers incorrectly in the session
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  incorrect: number;
  /**
   * True if the learner completed the session and clicks done, false if they exit early
   */
  session_completed: boolean;
  /**
   * The number of slides the learner completed in the session
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  slides_attempted: number;
  /**
   * Total number of slides available in the current brain boost session
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  slides_available: number;
}

export interface BrainBoostLearnerOpenProperties {
  /**
   * What page it was clicked from.
   */
  from: string;
  /**
   * Where the learner opened Brain Boost from
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | card, header-icon, menu-item, empty-state, empty-state-course-library-search |
   */
  trigger: "card" | "header-icon" | "menu-item" | "empty-state" | "empty-state-course-library-search";
}

export interface BrainBoostOpenPickerProperties {
  course_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | course-card-icon, boost-slides-button, course-table, course-settings, get-started |
   */
  trigger: "course-card-icon" | "boost-slides-button" | "course-table" | "course-settings" | "get-started";
}

export interface BrainBoostRemoveCourseProperties {
  course_id: string;
}

export interface BrainBoostStartSessionProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  session_count: number;
}

export interface BrandomaticEditLogoOrColoursProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | delete logo, upload logo, background colour picker, background custom colour, text colour picker, text custom colour |
   */
  type:
    | "delete logo"
    | "upload logo"
    | "background colour picker"
    | "background custom colour"
    | "text colour picker"
    | "text custom colour";
  value?: string;
}

export interface BrandomaticWebsiteFetchedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | loaded, failed |
   */
  type: "loaded" | "failed";
  value: string;
}

export interface CertificateSharedProperties {
  course_id: string;
}

export interface CertificatesBulkDownloadedProperties {
  course_id?: string;
  course_title?: string;
}

export interface ChangePlaylistTypeProperties {
  /**
   * Playlist ID
   */
  playlist_id?: string;
  /**
   * Whether a playlist is "free form" or "sequential".
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Free, Sequential |
   */
  playlist_type?: "Free" | "Sequential";
}

export interface ChecklistOpenedProperties {
  opened_from?: string;
  opened_from_page?: string;
}

export interface ChecklistTaskLaunchedProperties {
  already_complete?: boolean;
  task?: string;
}

export interface ClickCardProperties {
  /**
   * The type of card it was clicked. Course, RR, Playlist, etc.
   */
  entity?: string;
  /**
   * What page it was clicked from.
   */
  from: string;
  /**
   * If the card was clicked from a section, what index of the section the card is.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  section_index?: number;
  /**
   * If the card was clicked from a section, what is the name of the section.
   */
  section_name?: string;
}

export interface ClickSignupButtonProperties {
  integration_source?: string;
  prompt_mode?: string;
}

export interface ClickedConnectIntegrationProperties {
  integration?: string;
}

export interface ClickedCreateFreeAccountProperties {
  email?: string;
}

export interface CompletedCreateRapidRefreshProperties {
  isImmediate?: boolean;
  title?: string;
  uploadedFile?: string;
}

export interface CourseCertificateDownloadedProperties {
  course_id?: string;
  course_title?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | lms, app |
   */
  source?: "lms" | "app";
}

export interface CourseCollectionCourseMovedProperties {
  course_collection_id: string;
  course_id: string;
}

export interface CourseCollectionCreatedProperties {
  course_collection_id: string;
}

export interface CourseCollectionOpenedProperties {
  course_collection_id: string;
}

export interface CourseEditedAnonymouslyProperties {
  courseTitle?: string;
  libraryAuthor?: string;
}

export interface CourseLanguageSwitchedProperties {
  isLanguageOriginal?: boolean;
}

export interface CourseLibraryCourseImportedProperties {
  /**
   * Where the learner opened Brain Boost from
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | card, preview |
   */
  trigger: "card" | "preview";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | quick-import, import-and-edit |
   */
  type: "quick-import" | "import-and-edit";
}

export interface CourseLibraryFilterSelectedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | featured, accredited |
   */
  filter_type?: "featured" | "accredited";
  industry?: string;
}

export interface CourseOverviewOpenedProperties {
  /**
   * Where the learner opened Brain Boost from
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | course-title, overview-menu |
   */
  trigger: "course-title" | "overview-menu";
}

export interface CoursePreviewLessonSwitchedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  lesson_number?: number;
}

export interface CoursePreviewTabClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | preview, details |
   */
  tab_name: "preview" | "details";
}

export interface CoursePreviewedProperties {
  course_title: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | course-card, course-page, content-library-card |
   */
  trigger: "course-card" | "course-page" | "content-library-card";
}

export interface CourseReviewCommentAddedProperties {
  is_reply: boolean;
}

export interface CourseReviewFinishedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  number_of_invitees: number;
  with_message: boolean;
}

export interface CourseReviewOpenedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | course page, deeplink, notification centre |
   */
  trigger: "course page" | "deeplink" | "notification centre";
}

export interface CourseReviewResolvedCommentProperties {
  is_resolved: boolean;
}

export interface CourseReviewToggledViewResolvedCommentsProperties {
  is_visible: boolean;
}

export interface CourseScheduledProperties {
  /**
   * This returns the number of briefcase documents added to a course at the time of publish
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  briefcase_count: number;
  /**
   * This returns the type of certificate enabled at the time that the admin publishes a course
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Customised, Default, Disabled |
   */
  certificate_type: "Customised" | "Default" | "Disabled";
  /**
   * This returns whether a course description is present at the time that the admin publishes the course
   */
  course_description: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | No due date, Specific due date |
   */
  due_date_applied?: "No due date" | "Specific due date";
  /**
   * This returns whether an end date was applied to a course at the time of publish
   */
  end_date_applied?: boolean;
  /**
   * This outlines the enrolment method (1) all users i.e., universal access or 2) user groups)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | All users, User groups |
   */
  enrollment_type?: "All users" | "User groups";
  /**
   * This returns whether an external_ID was set at the time of a course being published
   */
  external_ID?: boolean;
  group_training_enabled: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  leaderboard_enabled?: boolean;
  /**
   * This returns whether only specific lessons were required at the time of the course being published
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | all lessons count equally, specific lessons are required |
   */
  lessons_required?: "all lessons count equally" | "specific lessons are required";
  /**
   * This tracks whether the admin scheduled the course for an immediate or future date.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Now, Later |
   */
  schedule_status: "Now" | "Later";
  /**
   * This returns if the course setting was a standard completion or simple open at the time of publish.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | simple open, standard completion |
   */
  standard_completion_setting?: "simple open" | "standard completion";
  /**
   * The returns the linked translations set at the time the course is published.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  translations?: string[];
  /**
   * This outlines the number of user groups that have been enrolled in the course
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  usergroups_enrolled?: number;
  /**
   * This outlines the number of users enrolled in the course
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  users_enrolled?: number;
}

export interface CourseCompletedProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  lessonsCompleted?: number;
  type?: string;
  value?: string;
}

export interface CourseUnlockedProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  type?: string;
  value?: string;
}

export interface CreateALessonProperties {
  email?: {
    [k: string]: unknown;
  };
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | assessment, conference, course, discussion, lesson, playlist, collection, observation, group-training |
   */
  type:
    | "assessment"
    | "conference"
    | "course"
    | "discussion"
    | "lesson"
    | "playlist"
    | "collection"
    | "observation"
    | "group-training";
}

export interface CreateCourseClickedProperties {
  /**
   * Where the learner opened Brain Boost from
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | card, header-icon, menu-item, empty-state, empty-state-course-library-search, create-dropdown |
   */
  trigger:
    | "card"
    | "header-icon"
    | "menu-item"
    | "empty-state"
    | "empty-state-course-library-search"
    | "create-dropdown";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | generate-with-ai, create-blank, convert-a-document-with-ai, convert-a-ppt |
   */
  type: "generate-with-ai" | "create-blank" | "convert-a-document-with-ai" | "convert-a-ppt";
}

export interface CreateEducateAllAccountProperties {
  email?: string;
  success?: string;
}

export interface CreateEntrepriseAccountProperties {
  email?: string;
  success?: string;
}

export interface CreatedPasswordManuallyProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | user-profile, create_user, csv, public_api |
   */
  update_location: "user-profile" | "create_user" | "csv" | "public_api";
}

export interface CustomAchievementCreatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  features?: string[];
}

export interface DeeplinkOpenedProperties {
  "+clicked_branch_link"?: boolean;
  "+is_first_session"?: boolean;
  "+non_branch_link"?: string;
  "+referrer"?: string;
  $canonical_url?: string;
  $deeplink_path?: string;
}

export interface DeeplinkUsedProperties {
  _i?: string;
  _p?: string;
  "+click_timestamp"?: string;
  "+clicked_branch_link"?: boolean;
  "+is_first_session"?: boolean;
  "+match_guaranteed"?: string;
  "+non_branch_link"?: string;
  "+referrer"?: string;
  "~creation_source"?: string;
  "~id"?: string;
  "~referring_link"?: string;
  $android_passive_deepview?: string;
  $canonical_url?: string;
  $deeplink_path?: string;
  $identity_id?: string;
  $ios_passive_deepview?: string;
  $matching_ttl_s?: string;
  $one_time_use?: string;
  timestamp?: string;
}

export interface DeeplinkCopiedProperties {
  link?: string;
}

export interface DeeplinkDowloadedProperties {
  link?: string;
}

export interface DeletedRapidRefreshProperties {
  email?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
}

export interface DisableInviteLinkProperties {
  group_id?: string;
  invite_code?: string;
  invite_link?: string;
}

export interface DisabledIntegrationProperties {
  integration?: string;
}

export interface DocumentUnlockedProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  type?: string;
}

export interface DocumentViewedProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  type?: string;
  value?: string;
}

export interface EdappComContentLibrarySearchedProperties {
  search_term?: string;
}

export interface EditALessonProperties {
  course_status: string;
  course_title?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  email?: string;
  from_library?: boolean;
  is_uxp?: boolean;
  itlySchema?: string;
  itlySource?: string;
  itlyVersion?: string;
  lesson_status: string;
  lesson_title?: string;
  slides_changed?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  total_slides?: number;
  /**
   * To track version number of an entity
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  version_number: number;
}

export interface EditMediaFileProperties {
  file_type?: string;
}

export interface EnableInviteLinkProperties {
  group_id?: string;
  invite_code?: string;
  invite_link?: string;
}

export interface EnterInviteCodeOnCreateAccountProperties {
  code?: string;
  email?: string;
}

export interface ExistingDomainRedirectFromSignupFormProperties {
  email?: string;
}

export interface ExitMindfulLearningProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  actualDurationSeconds: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  lessonId: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  postCalm: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  postFocus: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  preCalm: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  preFocus: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  screen: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  selectedDurationSeconds: number;
}

export interface FailedRegistrationProperties {
  value?: string;
}

export interface FailedLoginProperties {
  /**
   * What page it was clicked from.
   */
  from: string;
  value?: string;
}

export interface FeedbackSubmittedProperties {
  comment?: string;
  course_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | happy, neutral, unhappy |
   */
  feedback_score: "happy" | "neutral" | "unhappy";
  feedback_type: string;
}

export interface FileUploadedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  file_size?: number;
  file_type?: string;
  location?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | media_library_button, upload_button, drag_n_drop, media_library_drag_n_drop |
   */
  source: "media_library_button" | "upload_button" | "drag_n_drop" | "media_library_drag_n_drop";
  success: boolean;
}

export interface GroupTrainingLearnerSelfRegisterProperties {
  course_id: string;
  session_id: string;
}

export interface GroupTrainingPreviewedProperties {
  course_id: string;
}

export interface GroupTrainingSessionCancelledProperties {
  course_id: string;
  session_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | group-training-card, session-modal |
   */
  trigger: "group-training-card" | "session-modal";
}

export interface GroupTrainingSessionEndedProperties {
  course_id: string;
  session_id: string;
}

export interface GroupTrainingSessionResumedProperties {
  course_id: string;
  session_id: string;
}

export interface GroupTrainingSessionStartedProperties {
  course_id: string;
  session_id: string;
}

export interface GroupTrainingViewReportProperties {
  course_id: string;
}

export interface InviteCodeEditedProperties {
  group_id?: string;
  invite_code: string;
}

export interface InviteLinkCopiedProperties {
  group_id?: string;
  invite_code?: string;
  invite_link?: string;
}

export interface InviteLinkQRCodeDownloadedProperties {
  group_id?: string;
  invite_code?: string;
  invite_link?: string;
}

export interface LeaderboardClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Course, Group, Individual, RapidRefresher |
   */
  type: "Course" | "Group" | "Individual" | "RapidRefresher";
}

export interface LeaderboardCreatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Group, Individual |
   */
  type: "Group" | "Individual";
}

export interface LeaderboardDisabledProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Rapid Refresh, Course |
   */
  type: "Rapid Refresh" | "Course";
}

export interface LeaderboardEnabledProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Rapid Refresh, Course |
   */
  type: "Rapid Refresh" | "Course";
}

export interface LearnerFilterAppliedProperties {
  filters?: string;
}

export interface LearnersAppCompleteSignUpProperties {
  account_type: string;
  email?: string;
}

export interface LessonClosedProperties {
  attempt_id?: string;
  has_seen_last_slide?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  /**
   * To track if a learner is attempting or reviewing a lesson
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | First attempt, Reattempt, View |
   */
  interaction_type: "First attempt" | "Reattempt" | "View";
  /**
   * Returns the time that a user spends on the page
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  time_spent: number;
}

export interface LessonDownloadedProperties {
  "Course Name"?: string;
  "Lesson Name"?: string;
}

export interface LessonStartedProperties {
  attempt_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  attempt_slide_completed_count?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
}

export interface LessonCompletedProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  score?: number;
  type?: string;
  value?: string;
}

export interface LessonUnlockedProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  type?: string;
  value?: string;
}

export interface LinkCopiedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | invite, public_course_preview |
   */
  link_type: "invite" | "public_course_preview";
}

export interface LinkEmailedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | course_edit |
   */
  link_type: "course_edit";
}

export interface LMSLibrarySearchedProperties {
  search_term?: string;
}

export interface LogoutProperties {
  appVersion?: string;
  type?: string;
  value?: string;
}

export interface MagicLinkSentProperties {
  type?: string;
}

export interface MandatoryToggledProperties {
  course_title?: string;
  date?: string;
  enabled?: boolean;
  type?: string;
}

export interface MediaLibraryFileSelectedProperties {
  file_type?: string;
  location?: string;
}

export interface MenuActionClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | share, edit, give_us_feedback, delete, enable_public_preview_link, disable_public_preview_link, share_with_collaborators, remove_access_to_collaborator |
   */
  action:
    | "share"
    | "edit"
    | "give_us_feedback"
    | "delete"
    | "enable_public_preview_link"
    | "disable_public_preview_link"
    | "share_with_collaborators"
    | "remove_access_to_collaborator";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | course, lesson |
   */
  menu_type: "course" | "lesson";
}

export interface NewAchievementProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  type?: string;
  value?: string;
}

export interface NewStarProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | assessment, conference, course, discussion, lesson, playlist, collection, observation, group-training |
   */
  type:
    | "assessment"
    | "conference"
    | "course"
    | "discussion"
    | "lesson"
    | "playlist"
    | "collection"
    | "observation"
    | "group-training";
  value?: string;
}

export interface NotificationOpenedProperties {
  body: string;
  title: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | AssessmentPostCommentCreated, DiscussionPostCommentCreated, RapidRefreshSessionStarted, SocialLearning, VideoCommentCreated, VideoCreated, BrainBoost, CourseReminder |
   */
  topic:
    | "AssessmentPostCommentCreated"
    | "DiscussionPostCommentCreated"
    | "RapidRefreshSessionStarted"
    | "SocialLearning"
    | "VideoCommentCreated"
    | "VideoCreated"
    | "BrainBoost"
    | "CourseReminder";
  type?: string;
  url?: string;
}

export interface ObservationPreviewedProperties {
  observation_id: string;
}

export interface ObservationResultsDownloadedProperties {
  observation_id: string;
}

export interface ObservationSubmissionCompletedProperties {
  observation_id: string;
  passed: boolean;
  submission_id: string;
}

export interface ObservationSubmissionResumedProperties {
  observation_id: string;
  submission_id: string;
}

export interface ObservationSubmissionSavedProperties {
  observation_id: string;
  submission_id: string;
}

export interface ObservationSubmissionStartedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  number_of_attempts: number;
  observation_id: string;
}

export interface ObservationSubmissionSubmittedProperties {
  observation_id: string;
  submission_id: string;
}

export interface OpenCourseProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  type?: string;
}

export interface OpenLessonProperties {
  appVersion?: string;
  attempt?: string;
  courseId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  earned_stars?: number;
  /**
   * The type of card it was clicked. Course, RR, Playlist, etc.
   */
  entity?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  /**
   * To track if a learner is attempting or reviewing a lesson
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | First attempt, Reattempt, View |
   */
  interaction_type: "First attempt" | "Reattempt" | "View";
  lessonExternalIdentifier?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  max_stars?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  needed_score?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  needed_stars?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Lesson, Assessment, Discussion, Conference, Observation |
   */
  type?: "Lesson" | "Assessment" | "Discussion" | "Conference" | "Observation";
  value?: string;
}

export interface OpenRapidRefreshProperties {
  type?: string;
}

export interface OpenedChangeLogProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | course, lesson |
   */
  type: "course" | "lesson";
}

export interface OpenedCourseLearnerAssignmentProperties {
  /**
   * Where the admin triggered the Assign button from
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Publish step, Overview page |
   */
  trigger?: "Publish step" | "Overview page";
}

export interface OpenedSettingsModalProperties {
  title?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | assessment, conference, course, discussion, lesson, playlist, collection, observation, group-training |
   */
  type:
    | "assessment"
    | "conference"
    | "course"
    | "discussion"
    | "lesson"
    | "playlist"
    | "collection"
    | "observation"
    | "group-training";
}

export interface OpenedBrowserProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | assessment, conference, course, discussion, lesson, playlist, collection, observation, group-training |
   */
  type:
    | "assessment"
    | "conference"
    | "course"
    | "discussion"
    | "lesson"
    | "playlist"
    | "collection"
    | "observation"
    | "group-training";
  value?: string;
}

export interface PageSizeUpdatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  results_per_page?: number;
}

export interface PlaylistOpenedByLearnerProperties {
  /**
   * Playlist ID
   */
  playlist_id?: string;
  /**
   * Whether a playlist is "free form" or "sequential".
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Free, Sequential |
   */
  playlist_type?: "Free" | "Sequential";
}

export interface PopulatedFieldsOnUserProfileProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  fields_assigned: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | user-profile, create_user, csv, public_api |
   */
  update_location: "user-profile" | "create_user" | "csv" | "public_api";
  user_id: string;
}

export interface PPTContentEditedProperties {
  course_id?: string;
  /**
   * This tracks the number of lessons that were created before the user progressed to step 2 (edit content)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  total_lessons?: number;
  /**
   * This tracks the number of slides that the user has transformed into another slide type
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  total_templates_modified?: number;
}

export interface PPTFileUploadedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  file_size?: number;
  success: boolean;
}

export interface PrivacyPolicyClickedProperties {
  type?: string;
}

export interface PublicPPTSubmittedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  file_size?: number;
  success: boolean;
}

export interface PublicTryActionClickedProperties {
  is_edapp?: boolean;
}

export interface RapidRefreshScheduledProperties {
  end_date?: string;
  /**
   * This outlines the enrolment method (1) all users i.e., universal access or 2) user groups)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | All users, User groups |
   */
  enrollment_type?: "All users" | "User groups";
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  language?: string;
  leaderboard_enabled?: boolean;
  logo_applied?: boolean;
  name?: string;
  prerequisites_applied?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Once, Daily, Weekly |
   */
  quiz_type?: "Once" | "Daily" | "Weekly";
  retries_enabled?: boolean;
  start_date?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  total_questions?: number;
  /**
   * This outlines the number of user groups that have been enrolled in the course
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  usergroups_enrolled?: number;
  /**
   * This outlines the number of users enrolled in the course
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  users_enrolled?: number;
}

export interface RapidRefreshCompletedProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  lessonsCompleted?: string;
  type?: string;
  value?: string;
}

export interface RapidRefreshSessionCompletedProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  lessonsCompleted?: number;
  type?: string;
  value?: string;
}

export interface RecentSearchItemClickedProperties {
  text?: string;
}

export interface RegisterViaInviteCodeProperties {
  appVersion?: string;
  code?: string;
  email?: string;
  userAgent?: string;
  userId?: string;
}

export interface RegisterViaInviteCodeFailureProperties {
  code?: string;
  email?: string;
  /**
   * Types of error from the server
   */
  error_code: string;
}

export interface RegisterWithoutEmailProperties {
  code?: string;
  email?: string;
}

export interface ResetCourseProgressProperties {
  course_id: string;
  user_id: string;
}

export interface ResetCourseCompletionProperties {
  appVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  type?: string;
}

export interface SavedCourseLearnerAssignmentProperties {
  /**
   * Where the admin changed the Assignation from
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Publish step, Overview page |
   */
  trigger?: "Publish step" | "Overview page";
}

export interface SearchAutoSuggestItemClickedProperties {
  description?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  metadata?: {
    [k: string]: unknown;
  };
  thumbnail?: string;
  title?: string;
  type?: string;
}

export interface SearchResultClickedProperties {
  description?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  metadata?: {
    [k: string]: unknown;
  };
  thumbnail?: string;
  title?: string;
  type?: string;
}

export interface SearchResultsRequestedProperties {
  text?: string;
}

export interface SettingsChangedProperties {
  courseId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | observation_result_access, enable_group_training |
   */
  setting: "observation_result_access" | "enable_group_training";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | assessment, conference, course, discussion, lesson, playlist, collection, observation, group-training |
   */
  type:
    | "assessment"
    | "conference"
    | "course"
    | "discussion"
    | "lesson"
    | "playlist"
    | "collection"
    | "observation"
    | "group-training";
}

export interface ShareActionClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | enable_public_preview_link, disable_public_preview_link, shared_with_collaborators, removed_access_collaborator, qr_code_downloaded, manage_link |
   */
  action:
    | "enable_public_preview_link"
    | "disable_public_preview_link"
    | "shared_with_collaborators"
    | "removed_access_collaborator"
    | "qr_code_downloaded"
    | "manage_link";
}

export interface SlideAICreatePromptGeneratedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Questions, Text |
   */
  ai_slide_type: "Questions" | "Text";
  topic_input: string;
}

export interface SortUsersTableProperties {
  column_header: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Ascending, Descending |
   */
  direction: "Ascending" | "Descending";
}

export interface SpinAndLooseProperties {
  appVersion?: string;
  type?: string;
}

export interface SpinAndWinProperties {
  appVersion?: string;
  type?: string;
}

export interface SSORedirectLinkOnSignupFormProperties {
  email?: string;
}

export interface SSORedirectSuccessProperties {
  company?: string;
}

export interface StarBarPlayProperties {
  /**
   * Tracks the game that the learner is playing
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | gift_grab, spin_to_win, star_bids, lucky_dip |
   */
  game: "gift_grab" | "spin_to_win" | "star_bids" | "lucky_dip";
}

export interface SurveysFilterAppliedProperties {
  filters?: string;
  searchTerm?: string;
}

export interface SwitchedAnalyticsReportProperties {
  is_legacy: boolean;
  report: string;
}

export interface TapLockedCourseProperties {
  /**
   * Is the locked course part of a sequential playlist
   */
  is_course_seq_playlist?: boolean;
}

export interface TapLockedRapidRefreshProperties {
  type?: string;
}

export interface TermsAndConditionsClickedProperties {
  type?: string;
}

export interface TrainingReportExportedProperties {
  course_id: string;
  /**
   * Captures the time a user requesting to download a report and the report opening. Time captured in seconds
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  download_time: number;
  /**
   * Returns the feature that the export relates to
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Group Training, Practical Assessment |
   */
  feature: "Group Training" | "Practical Assessment";
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  id?: string;
  session_id?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | all, session |
   */
  type: "all" | "session";
}

export interface TranslationActionClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | create-translation, ai-translation, manual-translation, link-translation, unlink-translation, overwrite-content-download, original-language |
   */
  action:
    | "create-translation"
    | "ai-translation"
    | "manual-translation"
    | "link-translation"
    | "unlink-translation"
    | "overwrite-content-download"
    | "original-language";
  language?: string;
}

export interface UpdateBrandingProperties {
  is_uxp?: boolean;
  itlySchema?: string;
  itlySource?: string;
  itlyVersion?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | lesson, course |
   */
  level: "lesson" | "course";
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  type: string[];
}

export interface UpdateDefaultBrandingProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | logo, css, background_image, colors |
   */
  type: "logo" | "css" | "background_image" | "colors";
}

export interface UpgradeToProClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | recurring-certification, advanced-certificates |
   */
  via_feature: "recurring-certification" | "advanced-certificates";
}

export interface UploadAttemptOverSizeLimitProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  file_size?: number;
  file_type?: string;
}

export interface UploadUserCSVClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | add, replace |
   */
  editRoles: "add" | "replace";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | replace, add |
   */
  editUserGroups: "replace" | "add";
  sendInvitationsEnabled: boolean;
  uploadSuccessful: boolean;
}

export interface UserDeletedProperties {
  user_id: string;
}

export interface UserListBulkActionAppliedProperties {
  bulk_action_type: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  users_selected: number;
}

export interface UserListBulkUpdateManagedUserGroupsProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  number_user_groups: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | add, replace |
   */
  update_mode: "add" | "replace";
}

export interface UserListBulkUpdateRolesProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  role_list: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | add, replace |
   */
  update_mode: "add" | "replace";
}

export interface UserListBulkUpdateUserGroupsProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  number_user_groups: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | add, replace |
   */
  update_mode: "add" | "replace";
}

export interface UserListFiltersAppliedProperties {
  filter_by_date_registered_end?: string;
  filter_by_date_registered_start?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  filter_by_invited?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  filter_by_logged_in?: string[];
  /**
   * Filter by one or more preset system roles
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  filter_by_roles?: string[];
  /**
   * Count of the number of user groups filtered by the admin
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  filter_by_user_groups?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  filter_by_verified?: string[];
}

export interface UserListSelectUsersProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  current_page_number?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  results_per_page?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | user-list, secondary-search |
   */
  selection_location: "user-list" | "secondary-search";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  users_selected: number;
}

export interface UserListViewedBulkReviewModalProperties {
  bulk_action_type: string;
}

export interface UserListViewedBulkSelectModalProperties {
  bulk_action_type: string;
}

export interface UserListViewedSecondarySearchModalProperties {
  bulk_action_type: string;
}

export interface UserVerifiedProperties {
  user_id: string;
}

export interface VideoPlaybackCompletedProperties {
  position?: string;
  title?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  total_length?: number;
}

export interface VideoPlaybackPausedProperties {
  position?: string;
  title?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  total_length?: number;
}

export interface VideoPlaybackResumedProperties {
  position?: string;
  title?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  total_length?: number;
}

export interface VideoPlaybackStartedProperties {
  position?: string;
  title?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  total_length?: number;
}

export interface ViewedCoursePublicPreviewProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  category?: string;
  is_edapp?: boolean;
  is_iframe?: boolean;
  lesson_only?: boolean;
  name?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  path: string;
  title?: string;
  url?: string;
}

export interface ViewedUserProfileTabProperties {
  profile_tab_name: string;
}

export interface WebsiteFieldPopulatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | manually entered, automatically entered, cleared |
   */
  type: "manually entered" | "automatically entered" | "cleared";
  value?: string;
}

export class AccountSignedUp implements Event {
  name = 'Account Signed Up';
  id = '899b4405-11c0-4f21-87ee-1794c2d7f748';
  version = '1.0.2';
}

export class AchievementsClicked implements Event {
  name = 'Achievements Clicked';
  id = '33ccc47e-d00e-430f-b571-c55c57a190fa';
  version = '1.0.1';

  constructor(
    public properties?: AchievementsClickedProperties,
  ) {}
}

export class AchievementsViewed implements Event {
  name = 'Achievements Viewed';
  id = 'bc39e7b1-f60a-41fc-be78-1fd4734b2c25';
  version = '1.0.1';
}

export class AddCoursesToPlaylist implements Event {
  name = 'Add Courses to Playlist';
  id = '3d3223b1-e496-4964-97a3-f1a9caa0dd34';
  version = '2.0.0';

  constructor(
    public properties: AddCoursesToPlaylistProperties,
  ) {}
}

export class AdminFilterApplied implements Event {
  name = 'admin filter applied';
  id = '081588d5-61d0-4615-b778-63462a1890fb';
  version = '3.0.3';

  constructor(
    public properties?: AdminFilterAppliedProperties,
  ) {}
}

export class AiCreateSlideAddedToLesson implements Event {
  name = 'AI Create Slide Added to Lesson';
  id = 'd7b0518d-a96c-4230-9a81-38db47d211d6';
  version = '1.0.0';

  constructor(
    public properties: AICreateSlideAddedToLessonProperties,
  ) {}
}

export class AiDocumentConverted implements Event {
  name = 'AI Document Converted';
  id = '7a1a568c-290a-44ec-aec5-5f0c1c4bd9f2';
  version = '1.0.0';

  constructor(
    public properties?: AIDocumentConvertedProperties,
  ) {}
}

export class AiGeneratedCourse implements Event {
  name = 'AI Generated Course';
  id = '0587aad3-0027-4783-94fc-b227c9cb8bdc';
  version = '2.0.2';

  constructor(
    public properties: AIGeneratedCourseProperties,
  ) {}
}

export class AiGeneratedLesson implements Event {
  name = 'AI Generated Lesson';
  id = '16295eb9-1998-4096-9144-577b5ea6bdf6';
  version = '1.0.1';

  constructor(
    public properties: AIGeneratedLessonProperties,
  ) {}
}

export class AiNarrationBulkNarrate implements Event {
  name = 'AI Narration Bulk Narrate';
  id = '871d162e-ff1c-4456-b0fe-477c802f170a';
  version = '1.0.0';
}

export class AiNarrationSelected implements Event {
  name = 'AI Narration Selected';
  id = 'e8d4d7a6-086a-4460-9c00-5fb318b9bbdf';
  version = '1.0.0';
}

export class AiNarrationVoiceApplied implements Event {
  name = 'AI Narration Voice Applied';
  id = '1594f80f-8510-4fb8-a65f-cc43e925a0ff';
  version = '1.0.0';

  constructor(
    public properties: AINarrationVoiceAppliedProperties,
  ) {}
}

export class AiTextEdited implements Event {
  name = 'AI Text Edited';
  id = 'e649f4c3-cb1a-4018-b6bd-5c8ef88e2b0b';
  version = '1.0.0';

  constructor(
    public properties: AITextEditedProperties,
  ) {}
}

export class AiobActionClicked implements Event {
  name = 'AIOB Action Clicked';
  id = '29f5ca56-fee2-457c-b842-3db00363257e';
  version = '9.0.0';

  constructor(
    public properties: AIOBActionClickedProperties,
  ) {}
}

export class AnalyticsFilterApplied implements Event {
  name = 'Analytics Filter Applied';
  id = '36e69e8c-c8b0-468c-b597-71923ca2cf5a';
  version = '1.0.1';

  constructor(
    public properties: AnalyticsFilterAppliedProperties,
  ) {}
}

export class AppOpen implements Event {
  name = 'App Open';
  id = 'a8c3b8e7-9f85-40c7-b9b7-4d1431dc59c1';
  version = '2.0.0';
}

export class AppUpdateCancelled implements Event {
  name = 'App update cancelled';
  id = '88e3fb5a-d25d-4408-9b8a-bc67c9d5cceb';
  version = '2.0.1';
}

export class AppUpdateClicked implements Event {
  name = 'App update clicked';
  id = '14ce4a81-6eeb-40ee-9cee-7e7251861a8c';
  version = '2.0.1';
}

export class ApplyCompanyLogoFromChecklist implements Event {
  name = 'Apply company logo from checklist';
  id = '95295594-d7e7-481b-9b65-9fe3aad8a6a6';
  version = '2.0.1';
}

export class AssignedRolesToUser implements Event {
  name = 'Assigned Roles to User';
  id = '7ce5bd29-4614-4693-b26c-634af1b15339';
  version = '1.0.0';

  constructor(
    public properties: AssignedRolesToUserProperties,
  ) {}
}

export class AssignedUserToGroups implements Event {
  name = 'Assigned User to Groups';
  id = 'b9abb9d6-63e7-4a3a-9269-64524585c9b5';
  version = '2.0.0';

  constructor(
    public properties: AssignedUserToGroupsProperties,
  ) {}
}

export class AssignedUsersGroupsToCourseLocation implements Event {
  name = 'Assigned Users Groups to Course Location';
  id = '042b2053-7993-463d-8bd3-73b607b1b504';
  version = '1.0.1';

  constructor(
    public properties: AssignedUsersGroupsToCourseLocationProperties,
  ) {}
}

export class BannerCreated implements Event {
  name = 'Banner Created';
  id = 'cad636a7-0850-4dfc-bd5d-e82f36e443e1';
  version = '2.0.1';

  constructor(
    public properties?: BannerCreatedProperties,
  ) {}
}

export class BannerDeleted implements Event {
  name = 'Banner Deleted';
  id = 'dc0e0576-ad68-4d02-8d86-1169ffb6d60b';
  version = '1.0.0';

  constructor(
    public properties: BannerDeletedProperties,
  ) {}
}

export class BannerOpened implements Event {
  name = 'Banner Opened';
  id = '5f0a778c-a5f4-4aed-a372-f9be7eb7ee3c';
  version = '1.0.0';

  constructor(
    public properties: BannerOpenedProperties,
  ) {}
}

export class BannerUpdated implements Event {
  name = 'Banner Updated';
  id = '5f91fb04-27ed-4bf5-a24d-be1dc3dc8005';
  version = '1.0.1';

  constructor(
    public properties: BannerUpdatedProperties,
  ) {}
}

export class BrainBoostAddCourse implements Event {
  name = 'Brain Boost Add Course';
  id = 'fef125d7-0bfe-4273-acc0-9e34180cde63';
  version = '1.0.1';

  constructor(
    public properties: BrainBoostAddCourseProperties,
  ) {}
}

export class BrainBoostContinueSession implements Event {
  name = 'Brain Boost Continue Session';
  id = '7073478d-534f-47f7-b366-1a217b428e09';
  version = '1.0.2';
}

export class BrainBoostEditCourse implements Event {
  name = 'Brain Boost Edit Course';
  id = '3448a5fd-dbc8-4a8b-8e26-9fe87348f247';
  version = '3.0.0';

  constructor(
    public properties: BrainBoostEditCourseProperties,
  ) {}
}

export class BrainBoostEditSettings implements Event {
  name = 'Brain Boost Edit Settings';
  id = '44542dcb-e829-4d24-9af1-47d71bc093e6';
  version = '1.0.1';

  constructor(
    public properties: BrainBoostEditSettingsProperties,
  ) {}
}

export class BrainBoostEndSession implements Event {
  name = 'Brain Boost End Session';
  id = '5d74dde1-504f-4b64-bc9a-bbb074490f90';
  version = '1.0.2';

  constructor(
    public properties: BrainBoostEndSessionProperties,
  ) {}
}

export class BrainBoostLearnerOpen implements Event {
  name = 'Brain Boost Learner Open';
  id = '9a83bb32-2795-46bf-a045-5b94ce67d136';
  version = '4.0.0';

  constructor(
    public properties: BrainBoostLearnerOpenProperties,
  ) {}
}

export class BrainBoostOpenPicker implements Event {
  name = 'Brain Boost Open Picker';
  id = '6eb95b21-12bd-494c-b068-134f21209e2f';
  version = '2.0.1';

  constructor(
    public properties: BrainBoostOpenPickerProperties,
  ) {}
}

export class BrainBoostRemoveCourse implements Event {
  name = 'Brain Boost Remove Course';
  id = 'b0b3af6c-8f48-46cc-8a06-94b1090594a7';
  version = '1.0.1';

  constructor(
    public properties: BrainBoostRemoveCourseProperties,
  ) {}
}

export class BrainBoostStartSession implements Event {
  name = 'Brain Boost Start Session';
  id = '0a6d617b-eec1-4d45-a42c-bee88f18c03b';
  version = '2.0.1';

  constructor(
    public properties: BrainBoostStartSessionProperties,
  ) {}
}

export class BrandomaticEditLogoOrColours implements Event {
  name = 'Brandomatic edit logo or colours';
  id = '3ebcfdd8-4466-4901-be23-fd31f96adfd4';
  version = '1.0.1';

  constructor(
    public properties: BrandomaticEditLogoOrColoursProperties,
  ) {}
}

export class BrandomaticWebsiteFetched implements Event {
  name = 'Brandomatic website fetched';
  id = 'cfda7156-31d6-4172-8d06-1677846a98d1';
  version = '1.0.2';

  constructor(
    public properties: BrandomaticWebsiteFetchedProperties,
  ) {}
}

export class BulkDeleteModalViewed implements Event {
  name = 'Bulk Delete Modal Viewed';
  id = 'b9384232-29a7-43a0-9c1f-551d72c2db5a';
  version = '1.0.0';
}

export class CertificateShared implements Event {
  name = 'Certificate Shared';
  id = '17254c9c-b995-479e-b1c0-b1746124972c';
  version = '1.0.0';

  constructor(
    public properties: CertificateSharedProperties,
  ) {}
}

export class CertificatesBulkDownloaded implements Event {
  name = 'Certificates Bulk Downloaded';
  id = 'f804c848-d9f2-4d51-af99-59099fdfe709';
  version = '1.0.1';

  constructor(
    public properties?: CertificatesBulkDownloadedProperties,
  ) {}
}

export class ChangePlaylistType implements Event {
  name = 'Change Playlist Type';
  id = '2d8e9aa3-22a7-4b13-945b-27e3fcc0219e';
  version = '2.0.0';

  constructor(
    public properties?: ChangePlaylistTypeProperties,
  ) {}
}

export class ChecklistOpened implements Event {
  name = 'Checklist opened';
  id = '0237d7c5-99d3-46be-bb5e-1d393f1a220c';
  version = '2.0.1';

  constructor(
    public properties?: ChecklistOpenedProperties,
  ) {}
}

export class ChecklistTaskLaunched implements Event {
  name = 'Checklist task launched';
  id = 'b6cb77b2-316f-4ac0-88df-eb54d16bc7f8';
  version = '2.0.1';

  constructor(
    public properties?: ChecklistTaskLaunchedProperties,
  ) {}
}

export class ClickCard implements Event {
  name = 'Click Card';
  id = 'd7c2b11b-21f7-4fd4-b34b-6b7fc944f30b';
  version = '2.0.0';

  constructor(
    public properties: ClickCardProperties,
  ) {}
}

export class ClickCreateLearnerAccountButton implements Event {
  name = 'Click Create Learner Account Button';
  id = '906d5c8d-47f5-4659-b1d7-9d8341b4ba61';
  version = '1.0.0';
}

export class ClickRegisterHereOnLogin implements Event {
  name = 'Click Register Here on Login';
  id = 'c6ddd4f3-1e7b-4a53-96cd-ca6298774fa5';
  version = '1.0.0';
}

export class ClickSignUpAsIndividualLearner implements Event {
  name = 'Click Sign Up As Individual Learner';
  id = 'bf40f0b5-e6b7-467a-96dc-6ca0047f3cfd';
  version = '1.0.0';
}

export class ClickSignUpAsTeamTrainer implements Event {
  name = 'Click Sign Up As Team Trainer';
  id = '2eee22c9-ee71-4832-926d-4d9590305b1f';
  version = '1.0.0';
}

export class ClickSignupButton implements Event {
  name = 'click signup button';
  id = '565a34b4-9637-405e-9e7c-1c59b74386c3';
  version = '1.0.1';

  constructor(
    public properties?: ClickSignupButtonProperties,
  ) {}
}

export class ClickTakeMeBackEndOfSignUp implements Event {
  name = 'Click Take Me Back End Of Sign Up';
  id = '8d5652d4-ace8-4ecd-94e1-c1e46847deb6';
  version = '1.0.0';
}

export class ClickTakeMeBackStartOfSignUp implements Event {
  name = 'Click Take Me Back Start Of Sign Up';
  id = '2b2f53fc-a565-4b33-9c9f-aebd764f0fec';
  version = '1.0.0';
}

export class ClickedConnectIntegration implements Event {
  name = 'Clicked Connect Integration';
  id = 'e5c60b59-9b95-43d4-b4f1-9d6522d4683d';
  version = '2.0.1';

  constructor(
    public properties?: ClickedConnectIntegrationProperties,
  ) {}
}

export class ClickedCreateFreeAccount implements Event {
  name = 'clicked create free account';
  id = '5a5c0fbd-d30b-4fa9-afde-7535948abda3';
  version = '1.0.1';

  constructor(
    public properties?: ClickedCreateFreeAccountProperties,
  ) {}
}

export class CompletedCreateRapidRefresh implements Event {
  name = 'completed-create-rapid-refresh';
  id = '3f1fd143-3ca3-417b-b33c-837c357367ec';
  version = '3.0.1';

  constructor(
    public properties?: CompletedCreateRapidRefreshProperties,
  ) {}
}

export class CourseCertificateDownloaded implements Event {
  name = 'Course Certificate Downloaded';
  id = '7a066be4-78cd-4e79-b449-d6efd045de44';
  version = '1.0.0';

  constructor(
    public properties?: CourseCertificateDownloadedProperties,
  ) {}
}

export class CourseCollectionCourseMoved implements Event {
  name = 'Course Collection Course Moved';
  id = 'b9330fd5-b5fa-4e92-ad01-25d95d361ee0';
  version = '1.0.1';

  constructor(
    public properties: CourseCollectionCourseMovedProperties,
  ) {}
}

export class CourseCollectionCreated implements Event {
  name = 'Course Collection Created';
  id = '233b5edf-898c-480f-b1f4-84e554ecbdc2';
  version = '1.0.1';

  constructor(
    public properties: CourseCollectionCreatedProperties,
  ) {}
}

export class CourseCollectionOpened implements Event {
  name = 'Course Collection Opened';
  id = '83fe83f7-bc69-472c-b258-bc6bdca5052d';
  version = '1.0.0';

  constructor(
    public properties: CourseCollectionOpenedProperties,
  ) {}
}

export class CourseDeleted implements Event {
  name = 'Course Deleted';
  id = 'a055cb83-2912-42b1-a322-31521ae2942b';
  version = '1.0.0';
}

export class CourseEditedAnonymously implements Event {
  name = 'Course Edited Anonymously';
  id = 'd911e5d4-84d2-4f27-8162-8e3ee0644f59';
  version = '1.0.1';

  constructor(
    public properties?: CourseEditedAnonymouslyProperties,
  ) {}
}

export class CourseImportedFromRecommendedSection implements Event {
  name = 'Course imported from recommended section';
  id = '0f05c20a-729e-4095-8c07-ebc6296ea2c2';
  version = '1.0.1';
}

export class CourseLanguageSwitched implements Event {
  name = 'Course Language Switched';
  id = '452322dc-a310-4930-89d5-6c638c16137b';
  version = '1.0.0';

  constructor(
    public properties?: CourseLanguageSwitchedProperties,
  ) {}
}

export class CourseLibraryCourseImported implements Event {
  name = 'Course Library Course Imported';
  id = '1b4c93c1-fec7-46d8-9df8-e65058569c78';
  version = '1.0.0';

  constructor(
    public properties: CourseLibraryCourseImportedProperties,
  ) {}
}

export class CourseLibraryFilterSelected implements Event {
  name = 'Course Library Filter Selected';
  id = '79a9e5dd-f639-4c79-af26-9febf9250025';
  version = '1.0.0';

  constructor(
    public properties?: CourseLibraryFilterSelectedProperties,
  ) {}
}

export class CourseOverviewOpened implements Event {
  name = 'Course Overview Opened';
  id = '1b9d4fac-57e9-498b-a658-c9692561b061';
  version = '1.0.1';

  constructor(
    public properties: CourseOverviewOpenedProperties,
  ) {}
}

export class CoursePreviewLessonSwitched implements Event {
  name = 'Course Preview Lesson Switched';
  id = '8dcedddc-1136-45f9-ba88-4c96b65b949f';
  version = '1.0.0';

  constructor(
    public properties?: CoursePreviewLessonSwitchedProperties,
  ) {}
}

export class CoursePreviewTabClicked implements Event {
  name = 'Course Preview Tab Clicked';
  id = '0133a7a8-a889-42db-8d7e-93dea2bfaa5d';
  version = '1.0.0';

  constructor(
    public properties: CoursePreviewTabClickedProperties,
  ) {}
}

export class CoursePreviewed implements Event {
  name = 'Course Previewed';
  id = '53448f97-f630-46e6-a21d-fc477a884b23';
  version = '3.0.2';

  constructor(
    public properties: CoursePreviewedProperties,
  ) {}
}

export class CourseReviewCommentAdded implements Event {
  name = 'Course Review Comment Added';
  id = 'f20786c8-d998-4a1c-a8c1-e179bc7ae841';
  version = '1.0.0';

  constructor(
    public properties: CourseReviewCommentAddedProperties,
  ) {}
}

export class CourseReviewFinished implements Event {
  name = 'Course Review Finished';
  id = '5fee9afd-c99d-409d-91bc-dafcc1092768';
  version = '1.0.2';

  constructor(
    public properties: CourseReviewFinishedProperties,
  ) {}
}

export class CourseReviewOpened implements Event {
  name = 'Course Review Opened';
  id = 'f0c5a3e2-30ef-47fd-bc23-6e0532a650bb';
  version = '1.0.0';

  constructor(
    public properties: CourseReviewOpenedProperties,
  ) {}
}

export class CourseReviewResolvedComment implements Event {
  name = 'Course Review Resolved Comment';
  id = 'a1124d60-f92d-49b2-bd2c-f880cef833bb';
  version = '1.0.0';

  constructor(
    public properties: CourseReviewResolvedCommentProperties,
  ) {}
}

export class CourseReviewToggledViewResolvedComments implements Event {
  name = 'Course Review Toggled View Resolved Comments';
  id = 'ab09aa22-2e26-4a80-8ac6-ecd19bffb237';
  version = '1.0.0';

  constructor(
    public properties: CourseReviewToggledViewResolvedCommentsProperties,
  ) {}
}

export class CourseScheduled implements Event {
  name = 'Course Scheduled';
  id = '1d404ae8-ffd3-438e-8623-f57d9aafe81a';
  version = '3.0.0';

  constructor(
    public properties: CourseScheduledProperties,
  ) {}
}

export class CourseCompleted implements Event {
  name = 'course-completed';
  id = 'eebf8eab-1ef6-411a-914f-8129dee879e0';
  version = '6.0.0';

  constructor(
    public properties?: CourseCompletedProperties,
  ) {}
}

export class CourseUnlocked implements Event {
  name = 'course-unlocked';
  id = 'b6263bec-5bd5-4098-8101-e95b5f23a496';
  version = '5.0.0';

  constructor(
    public properties?: CourseUnlockedProperties,
  ) {}
}

export class CreateACourse implements Event {
  name = 'create a course';
  id = '8d2e0e02-993e-487e-b114-15078fc2f1f2';
  version = '2.0.1';
}

export class CreateALesson implements Event {
  name = 'create a lesson';
  id = 'e3a31219-a0d3-41f6-aff6-1c5d195dce95';
  version = '3.0.0';

  constructor(
    public properties: CreateALessonProperties,
  ) {}
}

export class CreateCourseClicked implements Event {
  name = 'Create Course Clicked';
  id = '2df39047-1ae7-48ca-9e97-b6b4efab0387';
  version = '3.0.0';

  constructor(
    public properties: CreateCourseClickedProperties,
  ) {}
}

export class CreateEducateAllAccount implements Event {
  name = 'create educateAll account';
  id = 'e936328c-00d9-405c-9ecb-450af436b630';
  version = '1.0.2';

  constructor(
    public properties?: CreateEducateAllAccountProperties,
  ) {}
}

export class CreateEntrepriseAccount implements Event {
  name = 'create entreprise account';
  id = '3aa8de8f-2d64-4bb7-8f16-cb06e1b3a164';
  version = '1.0.2';

  constructor(
    public properties?: CreateEntrepriseAccountProperties,
  ) {}
}

export class CreatedPasswordManually implements Event {
  name = 'Created Password Manually';
  id = '0a8edf27-d26c-4410-a46f-743ab36d4726';
  version = '1.0.0';

  constructor(
    public properties: CreatedPasswordManuallyProperties,
  ) {}
}

export class CustomAchievementArchived implements Event {
  name = 'Custom Achievement Archived';
  id = '2cb754b8-3ba5-491f-a092-4d28044075ba';
  version = '1.0.1';
}

export class CustomAchievementCreated implements Event {
  name = 'Custom Achievement Created';
  id = 'f487fe19-1e1e-487d-b04d-261528a2ccc0';
  version = '2.0.1';

  constructor(
    public properties?: CustomAchievementCreatedProperties,
  ) {}
}

export class CustomAchievementDeleted implements Event {
  name = 'Custom Achievement Deleted';
  id = '07f79ff3-d247-4742-90ec-f7c944f34125';
  version = '1.0.1';
}

export class CustomAchievementLive implements Event {
  name = 'Custom Achievement Live';
  id = '830b7b6e-f77a-4128-a95e-1ecd03e65a53';
  version = '1.0.1';
}

export class DeeplinkOpened implements Event {
  name = 'Deeplink Opened';
  id = '2ccdf4b7-d0dd-4a78-8b3a-7021fb3b9bcc';
  version = '3.0.2';

  constructor(
    public properties?: DeeplinkOpenedProperties,
  ) {}
}

export class DeeplinkUsed implements Event {
  name = 'Deeplink Used';
  id = '0dfac582-08f1-4db4-8159-10614b1ca108';
  version = '2.0.0';

  constructor(
    public properties?: DeeplinkUsedProperties,
  ) {}
}

export class DeeplinkCopied implements Event {
  name = 'deeplinkCopied';
  id = 'bfe1009b-2345-442b-8623-af37afba1daa';
  version = '2.0.1';

  constructor(
    public properties?: DeeplinkCopiedProperties,
  ) {}
}

export class DeeplinkDowloaded implements Event {
  name = 'deeplinkDowloaded';
  id = '8cabbfd0-9f0b-47e4-b590-079f119992b5';
  version = '2.0.1';

  constructor(
    public properties?: DeeplinkDowloadedProperties,
  ) {}
}

export class DeleteIndividualLearner implements Event {
  name = 'Delete Individual Learner';
  id = '0c8cb389-226f-415d-9d4a-b3d2718c1cb8';
  version = '1.0.0';
}

export class DeletedRapidRefresh implements Event {
  name = 'deleted-rapid-refresh';
  id = '9a5a313b-725c-41d5-b470-74aedbd88e58';
  version = '4.0.0';

  constructor(
    public properties?: DeletedRapidRefreshProperties,
  ) {}
}

export class DisableInviteLink implements Event {
  name = 'Disable invite link';
  id = '51e39fcf-76a3-4af5-82f3-48760fcdfa63';
  version = '2.0.1';

  constructor(
    public properties?: DisableInviteLinkProperties,
  ) {}
}

export class DisabledIntegration implements Event {
  name = 'Disabled Integration';
  id = 'cc1bc1ef-7e2b-4923-802f-042c8af9d8af';
  version = '2.0.1';

  constructor(
    public properties?: DisabledIntegrationProperties,
  ) {}
}

export class DocumentUnlocked implements Event {
  name = 'document-unlocked';
  id = '135c4c1d-e82d-4211-9f97-6b4e8312aa3a';
  version = '5.0.0';

  constructor(
    public properties?: DocumentUnlockedProperties,
  ) {}
}

export class DocumentViewed implements Event {
  name = 'document-viewed';
  id = '424e9849-c089-479d-bf74-91738fd4fadf';
  version = '5.0.0';

  constructor(
    public properties?: DocumentViewedProperties,
  ) {}
}

export class EdappComContentLibrarySearched implements Event {
  name = 'Edapp.com Content Library Searched';
  id = '2f9ebc8a-de02-46ab-972b-618462ad27c2';
  version = '1.0.1';

  constructor(
    public properties?: EdappComContentLibrarySearchedProperties,
  ) {}
}

export class EditALesson implements Event {
  name = 'edit a lesson';
  id = 'c6e6c7e2-57a8-4842-a032-cb69f59ca0a2';
  version = '8.0.0';

  constructor(
    public properties: EditALessonProperties,
  ) {}
}

export class EditMediaFile implements Event {
  name = 'Edit Media File';
  id = 'ed1523dd-063a-4d5f-bea2-192ce4787667';
  version = '1.0.0';

  constructor(
    public properties?: EditMediaFileProperties,
  ) {}
}

export class EnableInviteLink implements Event {
  name = 'Enable invite link';
  id = '164faa76-1ba6-43aa-95a6-7e0c5a0512a3';
  version = '2.0.1';

  constructor(
    public properties?: EnableInviteLinkProperties,
  ) {}
}

export class EnterInviteCodeOnCreateAccount implements Event {
  name = 'Enter Invite Code On Create Account';
  id = 'e5e56c47-38b2-483b-bb3a-d8273f8c51e8';
  version = '1.0.1';

  constructor(
    public properties?: EnterInviteCodeOnCreateAccountProperties,
  ) {}
}

export class ExistingDomainRedirectFromSignupForm implements Event {
  name = 'Existing domain redirect from signup form';
  id = '2e727a3a-bc48-403f-8e5f-8ce83e2d5ed8';
  version = '1.0.1';

  constructor(
    public properties?: ExistingDomainRedirectFromSignupFormProperties,
  ) {}
}

export class ExitMindfulLearning implements Event {
  name = 'Exit mindful learning';
  id = '6ca0764f-8edf-4b46-abd8-7838e5dd7622';
  version = '1.0.1';

  constructor(
    public properties: ExitMindfulLearningProperties,
  ) {}
}

export class FailedRegistration implements Event {
  name = 'Failed Registration';
  id = 'eee2520c-49a7-40fd-b071-1725b32830c3';
  version = '1.0.0';

  constructor(
    public properties?: FailedRegistrationProperties,
  ) {}
}

export class FailedSignUpEmailExists implements Event {
  name = 'Failed Sign Up Email Exists';
  id = '036dd9b9-e3d1-4211-b097-e37ef6990d8e';
  version = '1.0.0';
}

export class FailedSignUpSso implements Event {
  name = 'Failed Sign Up SSO';
  id = '3aa48c13-408d-4a26-9a2f-0e8d2cc9db58';
  version = '1.0.0';
}

export class FailedLogin implements Event {
  name = 'failed-login';
  id = '3cc61e17-19b4-4bdc-97a6-775dd83636bb';
  version = '3.0.0';

  constructor(
    public properties: FailedLoginProperties,
  ) {}
}

export class FeedbackSubmitted implements Event {
  name = 'Feedback Submitted';
  id = '3cbe15e6-7493-4c85-9ba8-957a89b78fd7';
  version = '3.0.0';

  constructor(
    public properties: FeedbackSubmittedProperties,
  ) {}
}

export class FileUploaded implements Event {
  name = 'File Uploaded';
  id = '5eb994d2-b4ca-4382-903a-e2daf98916a5';
  version = '1.0.1';

  constructor(
    public properties: FileUploadedProperties,
  ) {}
}

export class GoToCoursePageFromChecklist implements Event {
  name = 'Go to course page from checklist';
  id = '76c9c9f1-c9ba-4598-92bb-16e06cbc2907';
  version = '2.0.1';
}

export class GroupTrainingLearnerSelfRegister implements Event {
  name = 'Group Training Learner Self Register';
  id = 'a1f39355-ee16-413f-961f-99f314a0511b';
  version = '1.0.1';

  constructor(
    public properties: GroupTrainingLearnerSelfRegisterProperties,
  ) {}
}

export class GroupTrainingPreviewed implements Event {
  name = 'Group Training Previewed';
  id = 'c3a69da2-27fa-4860-8c90-75bb28c22609';
  version = '1.0.1';

  constructor(
    public properties: GroupTrainingPreviewedProperties,
  ) {}
}

export class GroupTrainingSessionCancelled implements Event {
  name = 'Group Training Session Cancelled';
  id = '4fbc0694-c48a-476c-9276-7ffe4725bd37';
  version = '1.0.1';

  constructor(
    public properties: GroupTrainingSessionCancelledProperties,
  ) {}
}

export class GroupTrainingSessionEnded implements Event {
  name = 'Group Training Session Ended';
  id = '813ed86f-a953-4494-bc88-dcc7299b3461';
  version = '1.0.1';

  constructor(
    public properties: GroupTrainingSessionEndedProperties,
  ) {}
}

export class GroupTrainingSessionResumed implements Event {
  name = 'Group Training Session Resumed';
  id = '01c29bd7-df32-4832-b93b-d08553e6a115';
  version = '1.0.1';

  constructor(
    public properties: GroupTrainingSessionResumedProperties,
  ) {}
}

export class GroupTrainingSessionStarted implements Event {
  name = 'Group Training Session Started';
  id = '107d67a9-8ef4-44cd-8544-33322f91f619';
  version = '1.0.1';

  constructor(
    public properties: GroupTrainingSessionStartedProperties,
  ) {}
}

export class GroupTrainingViewReport implements Event {
  name = 'Group Training View Report';
  id = '83cc0ca6-7a8d-4c1e-a92f-4d6c7966e237';
  version = '1.0.1';

  constructor(
    public properties: GroupTrainingViewReportProperties,
  ) {}
}

export class ImportAPptx implements Event {
  name = 'import a pptx';
  id = '9a3adda7-05c4-4949-8a0e-716e6b370138';
  version = '2.0.1';
}

export class InviteCodeEdited implements Event {
  name = 'Invite Code Edited';
  id = 'a65db42d-9f0e-4d20-a167-d01f0507ab3f';
  version = '1.0.1';

  constructor(
    public properties: InviteCodeEditedProperties,
  ) {}
}

export class InviteCodeValidatedOnSignUpForm implements Event {
  name = 'Invite code validated on sign up form';
  id = 'be913095-b115-4877-b0e9-c31f0f916979';
  version = '1.0.1';
}

export class InviteLinkCopied implements Event {
  name = 'Invite Link Copied';
  id = '5d9d088f-7eaa-4888-bfaf-9d8f21c22f17';
  version = '2.0.1';

  constructor(
    public properties?: InviteLinkCopiedProperties,
  ) {}
}

export class InviteLinkQrCodeDownloaded implements Event {
  name = 'Invite Link QR Code Downloaded';
  id = '4b819869-a9d5-47b1-b214-9d9c94123851';
  version = '2.0.1';

  constructor(
    public properties?: InviteLinkQRCodeDownloadedProperties,
  ) {}
}

export class InviteUsersViaEmail implements Event {
  name = 'invite users via email';
  id = '5dd1193a-062f-4c69-b82f-0c6adebea852';
  version = '2.0.1';
}

export class InvitedUserLogin implements Event {
  name = 'invited-user-login';
  id = 'f707e52f-e6ec-48c1-998a-c38e06e2aa59';
  version = '2.0.1';
}

export class LeaderboardClicked implements Event {
  name = 'leaderboard clicked';
  id = '815efef0-8f69-4ebb-a826-8bb869723b8e';
  version = '3.0.2';

  constructor(
    public properties: LeaderboardClickedProperties,
  ) {}
}

export class LeaderboardCreated implements Event {
  name = 'leaderboard created';
  id = 'a9b344d9-c8fc-498e-8254-e3433baae1d5';
  version = '2.0.1';

  constructor(
    public properties: LeaderboardCreatedProperties,
  ) {}
}

export class LeaderboardDisabled implements Event {
  name = 'leaderboard disabled';
  id = '1666be64-d983-467d-bbf8-0bd3c0ef48d2';
  version = '2.0.1';

  constructor(
    public properties: LeaderboardDisabledProperties,
  ) {}
}

export class LeaderboardEnabled implements Event {
  name = 'leaderboard enabled';
  id = 'fe862c22-877a-4543-b5ca-883098686eff';
  version = '2.0.1';

  constructor(
    public properties: LeaderboardEnabledProperties,
  ) {}
}

export class LearnerFilterApplied implements Event {
  name = 'learner filter applied';
  id = '0714898f-e113-4846-8a2a-568276b43786';
  version = '1.0.1';

  constructor(
    public properties?: LearnerFilterAppliedProperties,
  ) {}
}

export class LearnersAppCompleteSignUp implements Event {
  name = 'Learners App Complete Sign Up';
  id = '2d605265-461e-490d-a091-b3d59ebce5e9';
  version = '1.0.1';

  constructor(
    public properties: LearnersAppCompleteSignUpProperties,
  ) {}
}

export class LessonClosed implements Event {
  name = 'Lesson Closed';
  id = 'f29f8ad1-5e69-4c40-9b4f-b64f8e4d4eb8';
  version = '5.0.0';

  constructor(
    public properties: LessonClosedProperties,
  ) {}
}

export class LessonDownloaded implements Event {
  name = 'Lesson Downloaded';
  id = 'f17abf57-20f8-4b98-bb91-663cce55c280';
  version = '1.0.2';

  constructor(
    public properties?: LessonDownloadedProperties,
  ) {}
}

export class LessonStarted implements Event {
  name = 'Lesson Started';
  id = '457e77f8-88a9-464c-be53-a9024f4b604d';
  version = '5.0.0';

  constructor(
    public properties?: LessonStartedProperties,
  ) {}
}

export class LessonCompleted implements Event {
  name = 'lesson-completed';
  id = '418e2bbb-ce2c-4be2-a669-41d841fd9717';
  version = '7.0.0';

  constructor(
    public properties?: LessonCompletedProperties,
  ) {}
}

export class LessonUnlocked implements Event {
  name = 'lesson-unlocked';
  id = 'd4287b34-312f-481d-aadf-ce14e23d8aee';
  version = '5.0.0';

  constructor(
    public properties?: LessonUnlockedProperties,
  ) {}
}

export class LibraryOpened implements Event {
  name = 'Library Opened';
  id = 'e012710e-d1e8-4fa4-9f3f-a240a3a24efe';
  version = '2.0.1';
}

export class LinkCopied implements Event {
  name = 'Link Copied';
  id = '9f221e86-ecd8-4c55-9fb5-1b13ef06da79';
  version = '2.0.0';

  constructor(
    public properties: LinkCopiedProperties,
  ) {}
}

export class LinkEmailed implements Event {
  name = 'Link Emailed';
  id = '7475fa59-148d-4052-9862-09a63958e15f';
  version = '1.0.0';

  constructor(
    public properties: LinkEmailedProperties,
  ) {}
}

export class LmsLibrarySearched implements Event {
  name = 'LMS Library Searched';
  id = '9c2a50f9-d404-4cea-acfc-48b85ce1d10b';
  version = '2.0.1';

  constructor(
    public properties?: LMSLibrarySearchedProperties,
  ) {}
}

export class LoginRedirectToSso implements Event {
  name = 'Login Redirect To SSO';
  id = '02eb169b-8a5a-433f-b86f-90f1a9a4f56e';
  version = '1.0.0';
}

export class Logout implements Event {
  name = 'logout';
  id = '03a40a0d-35c4-4872-a088-c2da1fa3ccf6';
  version = '1.0.1';

  constructor(
    public properties?: LogoutProperties,
  ) {}
}

export class MagicLinkClicked implements Event {
  name = 'magic-link-clicked';
  id = '9f852b88-2a26-4ddf-ba40-5aebc55f26b7';
  version = '2.0.0';
}

export class MagicLinkSent implements Event {
  name = 'magic-link-sent';
  id = 'e9ae184d-5ad4-48bf-aa59-c98488bb3983';
  version = '1.0.1';

  constructor(
    public properties?: MagicLinkSentProperties,
  ) {}
}

export class MainLoginSuccess implements Event {
  name = 'Main Login Success';
  id = '3670fabe-a727-4c84-9d21-b8a0636a0b09';
  version = '1.0.1';
}

export class MandatoryToggled implements Event {
  name = 'Mandatory Toggled';
  id = 'f0af4def-9116-4f03-bddb-b00f5d62d264';
  version = '2.0.1';

  constructor(
    public properties?: MandatoryToggledProperties,
  ) {}
}

export class MediaLibraryFileSelected implements Event {
  name = 'Media Library File Selected';
  id = 'a62f389b-f373-4095-8fe9-e9538dfd36f5';
  version = '1.0.1';

  constructor(
    public properties?: MediaLibraryFileSelectedProperties,
  ) {}
}

export class MeetingPopupClick implements Event {
  name = 'meeting popup click';
  id = '6d6add95-84d9-4d71-97a2-6e26b779d07b';
  version = '1.0.2';
}

export class MenuActionClicked implements Event {
  name = 'Menu Action Clicked';
  id = '511c77e9-6823-4d3b-8b9a-35ffd0f1540e';
  version = '1.0.0';

  constructor(
    public properties: MenuActionClickedProperties,
  ) {}
}

export class NewAchievement implements Event {
  name = 'new-achievement';
  id = '07176c29-48a3-43bb-9715-bf04071c03a4';
  version = '3.0.0';

  constructor(
    public properties?: NewAchievementProperties,
  ) {}
}

export class NewStar implements Event {
  name = 'new-star';
  id = '2499f880-ae52-4dbe-8563-7de659c01d93';
  version = '2.0.0';

  constructor(
    public properties: NewStarProperties,
  ) {}
}

export class NotificationOpened implements Event {
  name = 'Notification Opened';
  id = 'ab1d0147-03b7-4c7d-b64f-f9dfaf898a5f';
  version = '3.0.0';

  constructor(
    public properties: NotificationOpenedProperties,
  ) {}
}

export class ObservationCreated implements Event {
  name = 'Observation Created';
  id = 'bd252ca6-f38d-41a4-9a4d-34ec006f18e1';
  version = '1.0.2';
}

export class ObservationPreviewed implements Event {
  name = 'Observation Previewed';
  id = 'bcf7eb3e-1547-4d69-8abf-534a5934fde0';
  version = '1.0.1';

  constructor(
    public properties: ObservationPreviewedProperties,
  ) {}
}

export class ObservationResultsDownloaded implements Event {
  name = 'Observation Results Downloaded';
  id = '76d006a6-12fb-4700-bc6f-77c012f34a76';
  version = '1.0.2';

  constructor(
    public properties: ObservationResultsDownloadedProperties,
  ) {}
}

export class ObservationSubmissionCompleted implements Event {
  name = 'Observation Submission Completed';
  id = 'b030c216-9288-4495-adfa-cf07f9e11aff';
  version = '2.0.2';

  constructor(
    public properties: ObservationSubmissionCompletedProperties,
  ) {}
}

export class ObservationSubmissionResumed implements Event {
  name = 'Observation Submission Resumed';
  id = '5623f3b1-62f5-47be-83ec-d2f8510bc580';
  version = '2.0.2';

  constructor(
    public properties: ObservationSubmissionResumedProperties,
  ) {}
}

export class ObservationSubmissionSaved implements Event {
  name = 'Observation Submission Saved';
  id = 'e37b513d-ad1a-49d1-8413-4e03d49cd8c5';
  version = '2.0.2';

  constructor(
    public properties: ObservationSubmissionSavedProperties,
  ) {}
}

export class ObservationSubmissionStarted implements Event {
  name = 'Observation Submission Started';
  id = 'ae25dd3e-26af-494a-a74f-2a4391855d24';
  version = '1.0.2';

  constructor(
    public properties: ObservationSubmissionStartedProperties,
  ) {}
}

export class ObservationSubmissionSubmitted implements Event {
  name = 'Observation Submission Submitted';
  id = '47abdac2-9a4b-4c46-b414-796803ee98a9';
  version = '2.0.2';

  constructor(
    public properties: ObservationSubmissionSubmittedProperties,
  ) {}
}

export class OpenMindfulLearning implements Event {
  name = 'Open mindful learning';
  id = '50b0faee-c777-4ee8-b181-2948ef8808e5';
  version = '1.0.1';
}

export class OpenCourse implements Event {
  name = 'open-course';
  id = '3f91fa59-cbaa-4a8d-b482-d3fa0d416bca';
  version = '5.0.0';

  constructor(
    public properties?: OpenCourseProperties,
  ) {}
}

export class OpenLesson implements Event {
  name = 'open-lesson';
  id = 'af018bbf-d151-47cd-99c8-e90c45ae356f';
  version = '7.0.0';

  constructor(
    public properties: OpenLessonProperties,
  ) {}
}

export class OpenRapidRefresh implements Event {
  name = 'open-rapid-refresh';
  id = 'f386770b-8f84-4aa1-afac-c8e055ef66a9';
  version = '1.0.1';

  constructor(
    public properties?: OpenRapidRefreshProperties,
  ) {}
}

export class OpenedChangeLog implements Event {
  name = 'Opened Change Log';
  id = '84fce9b1-d6aa-417b-8c1d-7e83023890a4';
  version = '1.0.1';

  constructor(
    public properties: OpenedChangeLogProperties,
  ) {}
}

export class OpenedCourseLearnerAssignment implements Event {
  name = 'Opened Course Learner Assignment';
  id = '122a1c53-706d-4d7c-a0e2-4f8e236a49bd';
  version = '1.0.2';

  constructor(
    public properties?: OpenedCourseLearnerAssignmentProperties,
  ) {}
}

export class OpenedCourseTranslationsDropdown implements Event {
  name = 'Opened Course Translations Dropdown';
  id = '5fc93220-041e-47f5-b781-4a7e360edb00';
  version = '1.0.1';
}

export class OpenedLessonReviewContent implements Event {
  name = 'Opened Lesson Review Content';
  id = 'df8e0d4a-90b4-489b-bfe5-d57718611d73';
  version = '1.0.1';
}

export class OpenedSettingsModal implements Event {
  name = 'Opened Settings Modal';
  id = '0191941f-57b0-47bc-a3ed-59b8f9b37f6e';
  version = '4.0.1';

  constructor(
    public properties: OpenedSettingsModalProperties,
  ) {}
}

export class OpenedThemeSettings implements Event {
  name = 'Opened Theme Settings';
  id = '826e5cda-45ed-4b40-88d1-1ad5ab5494db';
  version = '1.0.1';
}

export class OpenedBrowser implements Event {
  name = 'opened-browser';
  id = '54eaafcb-c441-4fef-9033-780ac833dcee';
  version = '2.0.0';

  constructor(
    public properties: OpenedBrowserProperties,
  ) {}
}

export class OutboundClickRegister implements Event {
  name = 'outbound click register';
  id = 'd2bb77ba-1fdb-47f5-b928-af4973d91fb7';
  version = '1.0.1';
}

export class PageSizeUpdated implements Event {
  name = 'Page Size Updated';
  id = '3cd01861-4cdd-484c-8ef1-fe737f582c9b';
  version = '1.0.1';

  constructor(
    public properties?: PageSizeUpdatedProperties,
  ) {}
}

export class PlaylistOpenedByLearner implements Event {
  name = 'Playlist Opened By Learner';
  id = 'e8904726-d8f1-4c8b-8085-2b60d7bf1fdf';
  version = '2.0.0';

  constructor(
    public properties?: PlaylistOpenedByLearnerProperties,
  ) {}
}

export class PopulatedFieldsOnUserProfile implements Event {
  name = 'Populated Fields on User Profile';
  id = 'd9c92003-552e-4b88-877e-00e355eadf44';
  version = '1.0.0';

  constructor(
    public properties: PopulatedFieldsOnUserProfileProperties,
  ) {}
}

export class PptButtonClicked implements Event {
  name = 'PPT Button Clicked';
  id = 'f780fe6c-b050-43a4-8a31-8e191f7db453';
  version = '1.0.1';
}

export class PptContentEdited implements Event {
  name = 'PPT Content Edited';
  id = '0650aa65-fb26-404b-9f59-277ee768b7a6';
  version = '1.0.0';

  constructor(
    public properties?: PPTContentEditedProperties,
  ) {}
}

export class PptConversionFormCompleted implements Event {
  name = 'PPT conversion form completed';
  id = 'e2b2c1fd-fd5e-4d8e-8c8f-2c66ab68ee3e';
  version = '1.0.1';
}

export class PptFileUploaded implements Event {
  name = 'PPT file uploaded';
  id = '2d59156a-1c49-44ba-ba81-e7abdd7c6445';
  version = '2.0.1';

  constructor(
    public properties: PPTFileUploadedProperties,
  ) {}
}

export class PptImmediateConversionSelected implements Event {
  name = 'PPT Immediate Conversion Selected';
  id = 'dc7dfd11-a8f5-40c1-98cc-68317be04f50';
  version = '1.0.1';
}

export class PpttiytConversionSelected implements Event {
  name = 'PPT TIYT Conversion Selected';
  id = '113a2d72-8efd-4023-988e-ccd9bee5b72a';
  version = '1.0.1';
}

export class PrivacyPolicyClicked implements Event {
  name = 'privacy-policy-clicked';
  id = 'ac9d6f99-8a55-4a0d-ad98-f5e18133ba4e';
  version = '1.0.1';

  constructor(
    public properties?: PrivacyPolicyClickedProperties,
  ) {}
}

export class PrizeDrawFinishCreate implements Event {
  name = 'Prize Draw Finish Create';
  id = '9aac5d0e-ef86-4865-a877-8da69d6bfc7b';
  version = '1.0.1';
}

export class PrizeDrawStartCreate implements Event {
  name = 'Prize Draw Start Create';
  id = '06d9f99c-697b-4ee9-b109-37eba6a3e87e';
  version = '1.0.1';
}

export class PublicPptChooseFileSelected implements Event {
  name = 'Public PPT Choose File Selected';
  id = 'b1adf58b-05f9-402b-abe2-3f7d8d3f190d';
  version = '1.0.0';
}

export class PublicPptSubmitted implements Event {
  name = 'Public PPT Submitted';
  id = 'f02215a0-9a27-48e3-965b-6527e8ed6709';
  version = '2.0.0';

  constructor(
    public properties: PublicPPTSubmittedProperties,
  ) {}
}

export class PublicTryActionClicked implements Event {
  name = 'Public Try Action Clicked';
  id = 'db15d8da-2af7-4c09-b62c-86ce37a1210d';
  version = '2.0.2';

  constructor(
    public properties?: PublicTryActionClickedProperties,
  ) {}
}

export class RapidRefreshScheduled implements Event {
  name = 'Rapid Refresh Scheduled';
  id = '5f1c89ce-f941-48fc-b302-7e393824c5ac';
  version = '3.0.0';

  constructor(
    public properties?: RapidRefreshScheduledProperties,
  ) {}
}

export class RapidRefreshCompleted implements Event {
  name = 'rapid-refresh-completed';
  id = '31420f57-2623-4139-bc2e-10b19217b3e4';
  version = '3.0.0';

  constructor(
    public properties?: RapidRefreshCompletedProperties,
  ) {}
}

export class RapidRefreshSessionCompleted implements Event {
  name = 'rapid-refresh-session-completed';
  id = '8f2e6e95-30f4-406b-82c4-5bbd5fb3739f';
  version = '4.0.0';

  constructor(
    public properties?: RapidRefreshSessionCompletedProperties,
  ) {}
}

export class RecentSearchItemClicked implements Event {
  name = 'Recent Search Item Clicked';
  id = '48711fda-c65c-4db0-b62f-38d6a8a31158';
  version = '1.0.1';

  constructor(
    public properties?: RecentSearchItemClickedProperties,
  ) {}
}

export class RegisterViaInviteCode implements Event {
  name = 'register via invite code';
  id = '4f82b6e5-31fd-4f75-8857-863d7ec11846';
  version = '1.0.2';

  constructor(
    public properties?: RegisterViaInviteCodeProperties,
  ) {}
}

export class RegisterViaInviteCodeFailure implements Event {
  name = 'Register via invite code failure';
  id = 'a434db42-daa7-4ba2-9968-7792a9431886';
  version = '1.0.0';

  constructor(
    public properties: RegisterViaInviteCodeFailureProperties,
  ) {}
}

export class RegisterWithoutEmail implements Event {
  name = 'Register Without Email';
  id = '144d8a6b-12a4-44b4-ae68-7a5e7d196010';
  version = '1.0.0';

  constructor(
    public properties?: RegisterWithoutEmailProperties,
  ) {}
}

export class ResetCourseProgress implements Event {
  name = 'Reset Course Progress';
  id = '2a0c2774-7b3a-4e1e-897c-34bed822574e';
  version = '1.0.0';

  constructor(
    public properties: ResetCourseProgressProperties,
  ) {}
}

export class ResetCourseCompletion implements Event {
  name = 'reset-course-completion';
  id = 'e995874a-69cb-4d99-8716-57d5c6210e88';
  version = '5.0.0';

  constructor(
    public properties?: ResetCourseCompletionProperties,
  ) {}
}

export class SavedCourseLearnerAssignment implements Event {
  name = 'Saved Course Learner Assignment';
  id = '3494ec91-d45a-4c79-88b0-8e8973763d53';
  version = '1.0.0';

  constructor(
    public properties?: SavedCourseLearnerAssignmentProperties,
  ) {}
}

export class SearchAutoSuggestItemClicked implements Event {
  name = 'Search Auto Suggest Item Clicked';
  id = 'd3fbf5d1-421b-4bf5-948a-a8ac41d9fb8c';
  version = '4.0.0';

  constructor(
    public properties?: SearchAutoSuggestItemClickedProperties,
  ) {}
}

export class SearchFunctionClicked implements Event {
  name = 'Search Function Clicked';
  id = '5f0857f1-af95-4494-864e-e43fd6ff3879';
  version = '1.0.1';
}

export class SearchResultClicked implements Event {
  name = 'Search Result Clicked';
  id = '2218406f-c45d-42e7-bd8d-30b7cbb348a9';
  version = '4.0.0';

  constructor(
    public properties?: SearchResultClickedProperties,
  ) {}
}

export class SearchResultsRequested implements Event {
  name = 'Search Results Requested';
  id = '76c1f369-b355-4aea-81f3-64501c331a30';
  version = '1.0.1';

  constructor(
    public properties?: SearchResultsRequestedProperties,
  ) {}
}

export class SelectSeeAllCoursesInRecommendedSection implements Event {
  name = 'Select see all courses in recommended section';
  id = '0948320d-249b-43af-8016-859e3d77817d';
  version = '1.0.2';
}

export class SettingsChanged implements Event {
  name = 'Settings Changed';
  id = '218ea18a-36bc-4d8a-b761-3bd224a61b3a';
  version = '4.0.1';

  constructor(
    public properties: SettingsChangedProperties,
  ) {}
}

export class ShareActionClicked implements Event {
  name = 'Share Action Clicked';
  id = 'f3de94e6-45a1-4aec-9dab-063ec32414ee';
  version = '3.0.0';

  constructor(
    public properties: ShareActionClickedProperties,
  ) {}
}

export class SlideAiCreatePromptGenerated implements Event {
  name = 'Slide AI Create Prompt Generated';
  id = '65bc611e-9c32-4262-8c9e-6c3f74407cdd';
  version = '2.0.0';

  constructor(
    public properties: SlideAICreatePromptGeneratedProperties,
  ) {}
}

export class SlideLibraryAiCreateOpened implements Event {
  name = 'Slide Library - AI Create Opened';
  id = '6f647b8d-f884-4f90-9c1f-a2ae2637199a';
  version = '1.0.0';
}

export class SortUsersTable implements Event {
  name = 'Sort Users Table';
  id = '5a69f975-f687-4848-ab4a-2b349b04708f';
  version = '1.0.1';

  constructor(
    public properties: SortUsersTableProperties,
  ) {}
}

export class SpinAndLoose implements Event {
  name = 'spin-and-loose';
  id = 'f5aab0e4-8cbd-467d-aa44-9b8f1c36e26b';
  version = '1.0.1';

  constructor(
    public properties?: SpinAndLooseProperties,
  ) {}
}

export class SpinAndWin implements Event {
  name = 'spin-and-win';
  id = '138d14aa-8a24-4246-aeac-297aa9c5614b';
  version = '1.0.1';

  constructor(
    public properties?: SpinAndWinProperties,
  ) {}
}

export class SsoRedirectLinkOnSignupForm implements Event {
  name = 'SSO redirect link on signup form';
  id = '5c0d5798-c40c-4e6b-92c5-2ed296f338d5';
  version = '1.0.1';

  constructor(
    public properties?: SSORedirectLinkOnSignupFormProperties,
  ) {}
}

export class SsoRedirectSuccess implements Event {
  name = 'SSO Redirect Success';
  id = '41e4101e-e900-468d-8e3f-d7bb41db6331';
  version = '1.0.0';

  constructor(
    public properties?: SSORedirectSuccessProperties,
  ) {}
}

export class StarBarOpen implements Event {
  name = 'Star Bar Open';
  id = '6b0b1204-01ae-470a-a7b6-30ed7a87c011';
  version = '1.0.0';
}

export class StarBarPlay implements Event {
  name = 'Star Bar Play';
  id = 'f3642e5e-eade-4af7-8239-133fc0985144';
  version = '1.0.0';

  constructor(
    public properties: StarBarPlayProperties,
  ) {}
}

export class StartCreateRapidRefresh implements Event {
  name = 'start-create-rapid-refresh';
  id = 'b5e78738-b84b-4a65-b637-730ab0a66a00';
  version = '2.0.1';
}

export class SuccessfulLogin implements Event {
  name = 'successful-login';
  id = 'f502a643-aeb5-4646-8d17-ec8cb238629e';
  version = '2.0.0';
}

export class SurveysFilterApplied implements Event {
  name = 'Surveys Filter Applied';
  id = '07aba6d0-8a10-49e4-9a06-e8e048ec155e';
  version = '1.0.1';

  constructor(
    public properties?: SurveysFilterAppliedProperties,
  ) {}
}

export class SurveysSearchResultClicked implements Event {
  name = 'Surveys Search Result Clicked';
  id = '7adb0f99-7b50-4a06-a31e-686164f3d6ae';
  version = '1.0.1';
}

export class SwitchedAnalyticsReport implements Event {
  name = 'Switched Analytics Report';
  id = 'a2787d69-5e84-4040-8fde-715fd032cd5e';
  version = '1.0.1';

  constructor(
    public properties: SwitchedAnalyticsReportProperties,
  ) {}
}

export class TapLockedCourse implements Event {
  name = 'tap-locked-course';
  id = '81dde826-2443-4974-9f5f-b3b439ce63f3';
  version = '2.0.1';

  constructor(
    public properties?: TapLockedCourseProperties,
  ) {}
}

export class TapLockedLesson implements Event {
  name = 'tap-locked-lesson';
  id = '6fdf4c96-fe4e-4a1c-b855-4757e3d40b97';
  version = '2.0.0';
}

export class TapLockedRapidRefresh implements Event {
  name = 'tap-locked-rapid-refresh';
  id = 'b5ebc777-9bd6-4044-bc78-dd34aa66f452';
  version = '1.0.1';

  constructor(
    public properties?: TapLockedRapidRefreshProperties,
  ) {}
}

export class TermsAndConditionsClicked implements Event {
  name = 'terms-and-conditions-clicked';
  id = 'd8af90e3-6194-4395-b974-73d8e089402b';
  version = '1.0.1';

  constructor(
    public properties?: TermsAndConditionsClickedProperties,
  ) {}
}

export class TrainingReportExported implements Event {
  name = 'Training Report Exported';
  id = 'f61bf3d3-cdd4-42bd-b391-0a1bb6fce32e';
  version = '2.0.1';

  constructor(
    public properties: TrainingReportExportedProperties,
  ) {}
}

export class TranslationActionClicked implements Event {
  name = 'Translation Action Clicked';
  id = '10b2cc79-56bf-4e81-b597-fdea5c070f9e';
  version = '3.0.0';

  constructor(
    public properties: TranslationActionClickedProperties,
  ) {}
}

export class UpdateBranding implements Event {
  name = 'Update Branding';
  id = '42d5344b-cbe4-4952-a1fb-d10da85f7e3f';
  version = '2.0.0';

  constructor(
    public properties: UpdateBrandingProperties,
  ) {}
}

export class UpdateDefaultBranding implements Event {
  name = 'Update default branding';
  id = '9bef00da-c8d7-4aff-9602-ca15a792c4cd';
  version = '2.0.0';

  constructor(
    public properties: UpdateDefaultBrandingProperties,
  ) {}
}

export class UpgradeToProClicked implements Event {
  name = 'Upgrade to Pro clicked';
  id = 'f15f21a0-c317-484a-886c-950381296775';
  version = '2.0.0';

  constructor(
    public properties: UpgradeToProClickedProperties,
  ) {}
}

export class UploadAttemptOverSizeLimit implements Event {
  name = 'Upload Attempt Over Size Limit';
  id = '59ed8c76-52e0-483a-9da5-39c939c94501';
  version = '1.0.0';

  constructor(
    public properties?: UploadAttemptOverSizeLimitProperties,
  ) {}
}

export class UploadUserCsvClicked implements Event {
  name = 'Upload User CSV Clicked';
  id = 'd1c852c2-587d-45a3-8e14-850a062b7193';
  version = '1.0.1';

  constructor(
    public properties: UploadUserCSVClickedProperties,
  ) {}
}

export class UserDeleted implements Event {
  name = 'User Deleted';
  id = '1e7db1b0-b3f0-438b-b8cc-96e0057417cc';
  version = '1.0.2';

  constructor(
    public properties: UserDeletedProperties,
  ) {}
}

export class UserListBulkActionApplied implements Event {
  name = 'User List Bulk Action Applied';
  id = '5431193d-ad2d-4b1d-b8bd-fa89d192b792';
  version = '2.0.0';

  constructor(
    public properties: UserListBulkActionAppliedProperties,
  ) {}
}

export class UserListBulkUpdateManagedUserGroups implements Event {
  name = 'User List Bulk Update Managed User Groups';
  id = '6db01c45-f2d5-4788-bd79-1ff020916c61';
  version = '1.0.0';

  constructor(
    public properties: UserListBulkUpdateManagedUserGroupsProperties,
  ) {}
}

export class UserListBulkUpdateRoles implements Event {
  name = 'User List Bulk Update Roles';
  id = '40630e83-f4f3-4e43-a7e8-f6b4b12034cc';
  version = '1.0.0';

  constructor(
    public properties: UserListBulkUpdateRolesProperties,
  ) {}
}

export class UserListBulkUpdateUserGroups implements Event {
  name = 'User List Bulk Update User Groups';
  id = '2f16de82-642a-4215-885f-9397508cf536';
  version = '1.0.0';

  constructor(
    public properties: UserListBulkUpdateUserGroupsProperties,
  ) {}
}

export class UserListFiltersApplied implements Event {
  name = 'User List Filters Applied';
  id = 'c6ad96aa-2cf4-45e8-9156-a456698fb579';
  version = '1.0.0';

  constructor(
    public properties?: UserListFiltersAppliedProperties,
  ) {}
}

export class UserListSelectUsers implements Event {
  name = 'User List Select Users';
  id = 'ac8b35b9-2625-4c66-bee2-fa6e6b6c2960';
  version = '2.0.0';

  constructor(
    public properties: UserListSelectUsersProperties,
  ) {}
}

export class UserListViewedBulkReviewModal implements Event {
  name = 'User List Viewed Bulk Review Modal';
  id = '5adb71cb-6ad2-4310-a975-9abbaf209f0b';
  version = '1.0.0';

  constructor(
    public properties: UserListViewedBulkReviewModalProperties,
  ) {}
}

export class UserListViewedBulkSelectModal implements Event {
  name = 'User List Viewed Bulk Select Modal';
  id = '743e0cd9-8d2b-43e9-8e10-552a606c9274';
  version = '1.0.0';

  constructor(
    public properties: UserListViewedBulkSelectModalProperties,
  ) {}
}

export class UserListViewedSecondarySearchModal implements Event {
  name = 'User List Viewed Secondary Search Modal';
  id = '2d2b03e1-014d-43e4-a2d7-a32034ecf428';
  version = '1.0.0';

  constructor(
    public properties: UserListViewedSecondarySearchModalProperties,
  ) {}
}

export class UserSelectsRegistrationSettingsFromInviteUsersPage implements Event {
  name = 'User Selects Registration Settings from Invite Users Page';
  id = 'f3fa4af3-55aa-4a62-ad5b-d926689cd211';
  version = '2.0.1';
}

export class UserVerified implements Event {
  name = 'User Verified';
  id = '9e4de2e4-66bc-4427-9563-a8d4e84caaff';
  version = '1.0.0';

  constructor(
    public properties: UserVerifiedProperties,
  ) {}
}

export class VideoPlaybackCompleted implements Event {
  name = 'Video Playback Completed';
  id = '0237d57c-eea0-4281-9aa1-95f995aaa006';
  version = '2.0.1';

  constructor(
    public properties?: VideoPlaybackCompletedProperties,
  ) {}
}

export class VideoPlaybackPaused implements Event {
  name = 'Video Playback Paused';
  id = 'c0e78c22-ba9e-40c3-9c39-ed17676dc6a4';
  version = '2.0.1';

  constructor(
    public properties?: VideoPlaybackPausedProperties,
  ) {}
}

export class VideoPlaybackResumed implements Event {
  name = 'Video Playback Resumed';
  id = 'bd39d2f4-7c50-4091-8d39-d6041c22d0f6';
  version = '2.0.1';

  constructor(
    public properties?: VideoPlaybackResumedProperties,
  ) {}
}

export class VideoPlaybackStarted implements Event {
  name = 'Video Playback Started';
  id = '24e8b646-068b-40d3-8512-16b91527184a';
  version = '2.0.1';

  constructor(
    public properties?: VideoPlaybackStartedProperties,
  ) {}
}

export class ViewedCoursePublicPreview implements Event {
  name = 'Viewed Course Public Preview';
  id = '6a58ed28-681a-4f59-a58a-89bbe41996fb';
  version = '2.0.1';

  constructor(
    public properties: ViewedCoursePublicPreviewProperties,
  ) {}
}

export class ViewedUserProfileTab implements Event {
  name = 'Viewed User Profile tab';
  id = '7590fd60-368d-49f0-9c05-67507f1f65b4';
  version = '1.0.0';

  constructor(
    public properties: ViewedUserProfileTabProperties,
  ) {}
}

export class WebsiteFieldPopulated implements Event {
  name = 'Website field populated';
  id = '9da0dd36-5d04-4050-9486-007ec153d9ad';
  version = '2.0.0';

  constructor(
    public properties: WebsiteFieldPopulatedProperties,
  ) {}
}

// prettier-ignore
interface DestinationOptions {
  segment?: SegmentOptions;
  all?: {
    disabled?: boolean;
  };
}

export interface LoadOptions extends OptionsBase {
  /**
   * Analytics provider-specific configuration.
   */
  destinations?: DestinationOptions;
}

// prettier-ignore
class Itly {
  private itly: ItlyBrowser;

  constructor() {
    this.itly = new ItlyBrowser();
  }

  /**
   * Initialize the Itly SDK. Call once when your application starts.
   * @param loadOptions Configuration options to initialize the Itly SDK with.
   */
  load(loadOptions: LoadOptions = {}) {
    const {
      destinations = {} as DestinationOptions,
      plugins = [] as Plugin[],
      ...options
    } = loadOptions;

    const destinationPlugins = destinations.all && destinations.all.disabled
      ? []
      : [
        new SegmentPlugin(options.environment === 'production'
          ? 'amPTgNDfAyL2B7zTIcUDEHu2xFfwpkKf'
          : 'nvUa8CRWpkSHu0PUzsH2seUp963mcyvO',
          destinations.segment,
        ),
      ];

    this.itly.load({
      ...options,
      plugins: [
        new SchemaValidatorPlugin({
          'group': {"type":"object","properties":{"[Amplitude] Group ID":{"type":"object"},"[Amplitude] Group name":{"type":"object"},"amplitudeType":{"type":"string"},"application_id":{"type":"string"},"application_name":{"type":"string"},"appName":{"type":"object"},"billing_plan":{"type":"string"},"channel":{"enum":["Self-Service","Enterprise","iAuditor","Educate-all"]},"company":{"type":"string"},"company_size":{"type":"string"},"context":{"type":"object"},"createdAt":{"type":"object"},"displayName":{"type":"object"},"email":{"type":"string"},"id":{"type":"object"},"isTrial":{"type":"boolean"},"name":{"type":"object"},"phone":{"type":"string"},"plan":{"type":"object"},"signup_creation_flow_cohort":{"enum":["A","B","control"]},"vertical":{"type":"string"},"website":{"type":"string"}},"additionalProperties":false,"required":[]},
          'identify': {"type":"object","properties":{"application_id":{"type":"string"},"application_name":{"type":"string"},"appVersion":{"type":"string"},"billing_plan":{"type":"string"},"company_size":{"type":"string"},"email":{"type":"string"},"firstname":{"type":"string"},"geolocation_country":{"type":"string"},"industry":{"type":"string"},"isTrial":{"type":"boolean"},"iwantto":{"items":{"type":"string"},"type":"array"},"jobtitle":{"type":"string"},"language":{"type":"string"},"lastname":{"type":"string"},"lifecyclestage":{"type":"string"},"name":{"type":"string"},"phone":{"type":"string"},"region":{"type":"string"},"roles":{"items":{"type":"string"},"uniqueItems":false,"type":"array"},"safety_culture_integration":{"enum":["Before","After"]},"safety_culture_sign_up":{"type":"boolean"},"sc_user_id":{"type":"string"},"sign_up_origin":{"type":"string"},"signed_up_on_app":{"type":"boolean"},"vertical":{"type":"string"}},"additionalProperties":false,"required":[]},
          'page': {"type":"object","properties":{"appVersion":{"type":"string"},"is_edapp":{"type":"boolean"},"is_iframe":{"type":"boolean"},"lesson_only":{"type":"boolean"},"network":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Account Signed Up': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Achievements Clicked': {"type":"object","properties":{"title":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Achievements Viewed': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Add Courses to Playlist': {"type":"object","properties":{"course_ids":{"items":{"type":"string"},"type":"array"},"playlist_id":{"type":"string"},"playlist_type":{"enum":["Free","Sequential"]}},"additionalProperties":false,"required":["course_ids"]},
          'admin filter applied': {"type":"object","properties":{"access":{"enum":["all","owned-or-shared"]},"date":{"type":"object"},"isGroupTrainingEnabled":{"type":"boolean"},"locales":{"items":{"type":"string"},"type":"array"},"status":{"type":"string"},"universalAccess":{"type":"boolean"},"usergroupIds":{"items":{"type":"string"},"uniqueItems":true,"type":"array"}},"additionalProperties":false,"required":[]},
          'AI Create Slide Added to Lesson': {"type":"object","properties":{"ai_slide_type":{"enum":["Questions","Text"]}},"additionalProperties":false,"required":["ai_slide_type"]},
          'AI Document Converted': {"type":"object","properties":{"document_type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'AI Generated Course': {"type":"object","properties":{"billing_plan":{"type":"string"},"course_id":{"type":"string"},"email":{"type":"string"},"file_extension":{"type":"string"},"file_name":{"type":"string"},"file_size":{"type":"number"},"file_type":{"type":"string"},"input_type":{"enum":["prompt","document"]},"number_of_images":{"type":"number"},"topic_input":{"type":"string"}},"additionalProperties":false,"required":["course_id","topic_input"]},
          'AI Generated Lesson': {"type":"object","properties":{"billing_plan":{"type":"string"},"course_id":{"type":"string"},"email":{"type":"string"},"topic_input":{"type":"string"}},"additionalProperties":false,"required":["course_id","topic_input"]},
          'AI Narration Bulk Narrate': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'AI Narration Selected': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'AI Narration Voice Applied': {"type":"object","properties":{"language":{"type":"string"},"voice":{"type":"string"}},"additionalProperties":false,"required":["voice"]},
          'AI Text Edited': {"type":"object","properties":{"action":{"enum":["rewrite","adjust_tone","reduce","extend"]}},"additionalProperties":false,"required":["action"]},
          'AIOB Action Clicked': {"type":"object","properties":{"action":{"enum":["add-section","expand-section","collapse-section","delete-section","expand-lesson-details","collapse-lesson-details","enable-code-view","disable-code-view","lesson-scorm-export","preview-custom-dimensions","skip-course-overview","hide-navigation","slide-selected","lesson-selected","slide-navigation-arrow","share-publicly","share-for-review","lesson-switcher","comment-tab","edit-tab","preview-tab","undo","redo","publish","language-picker","narration-added","navigate-edit","navigate-setup","navigate-publish"]},"isLanguageOriginal":{"type":"boolean"}},"additionalProperties":false,"required":["action"]},
          'Analytics Filter Applied': {"type":"object","properties":{"viz_filters_applied":{"items":{"type":"string"},"minItems":0,"type":"array"},"viz_filters_applied_value":{"items":{"type":"string"},"type":"array"},"viz_name":{"type":"string"},"viz_title":{"type":"string"}},"additionalProperties":false,"required":["viz_name"]},
          'App Open': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'App update cancelled': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'App update clicked': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Apply company logo from checklist': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Assigned Roles to User': {"type":"object","properties":{"roles_assigned":{"items":{"type":"string"},"type":"array"},"update_location":{"enum":["user-profile","create_user","csv","public_api"]},"user_id":{"type":"string"}},"additionalProperties":false,"required":["roles_assigned","update_location","user_id"]},
          'Assigned User to Groups': {"type":"object","properties":{"number_groups":{"type":"integer"}},"additionalProperties":false,"required":["number_groups"]},
          'Assigned Users Groups to Course Location': {"type":"object","properties":{"course_user_group_assign_location":{"enum":["Assign button","Publish modal"]},"selection_modified":{"type":"boolean"}},"additionalProperties":false,"required":["course_user_group_assign_location","selection_modified"]},
          'Banner Created': {"type":"object","properties":{"auto_branding":{"type":"boolean"},"banner_type":{"type":"string"},"has_url":{"type":"boolean"},"uploaded_image":{"type":"boolean"}},"additionalProperties":false,"required":[]},
          'Banner Deleted': {"type":"object","properties":{"banner_id":{"type":"string"}},"additionalProperties":false,"required":["banner_id"]},
          'Banner Opened': {"type":"object","properties":{"banner_id":{"type":"string"},"is_course_deeplink":{"type":"boolean"},"url":{"type":"string"}},"additionalProperties":false,"required":["banner_id"]},
          'Banner Updated': {"type":"object","properties":{"auto_branding":{"type":"boolean"},"banner_id":{"type":"string"},"banner_type":{"type":"string"},"has_url":{"type":"boolean"},"uploaded_image":{"type":"boolean"}},"additionalProperties":false,"required":["banner_id"]},
          'Brain Boost Add Course': {"type":"object","properties":{"course_count":{"type":"integer"},"course_ids":{"items":{"type":"string"},"type":"array"},"slide_count":{"type":"integer"}},"additionalProperties":false,"required":["course_count","course_ids","slide_count"]},
          'Brain Boost Continue Session': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Brain Boost Edit Course': {"type":"object","properties":{"course_id":{"type":"string"},"is_new":{"type":"boolean"},"slides_count":{"type":"number"}},"additionalProperties":false,"required":["course_id","is_new","slides_count"]},
          'Brain Boost Edit Settings': {"type":"object","properties":{"slides_per_session":{"type":"integer"}},"additionalProperties":false,"required":["slides_per_session"]},
          'Brain Boost End Session': {"type":"object","properties":{"correct":{"type":"number"},"incorrect":{"type":"number"},"session_completed":{"type":"boolean"},"slides_attempted":{"type":"number"},"slides_available":{"type":"number"}},"additionalProperties":false,"required":["correct","incorrect","session_completed","slides_attempted","slides_available"]},
          'Brain Boost Learner Open': {"type":"object","properties":{"from":{"type":"string"},"trigger":{"enum":["card","header-icon","menu-item","empty-state","empty-state-course-library-search"]}},"additionalProperties":false,"required":["from","trigger"]},
          'Brain Boost Open Picker': {"type":"object","properties":{"course_id":{"type":"string"},"trigger":{"enum":["course-card-icon","boost-slides-button","course-table","course-settings","get-started"]}},"additionalProperties":false,"required":["trigger"]},
          'Brain Boost Remove Course': {"type":"object","properties":{"course_id":{"type":"string"}},"additionalProperties":false,"required":["course_id"]},
          'Brain Boost Start Session': {"type":"object","properties":{"session_count":{"type":"number"}},"additionalProperties":false,"required":["session_count"]},
          'Brandomatic edit logo or colours': {"type":"object","properties":{"type":{"enum":["delete logo","upload logo","background colour picker","background custom colour","text colour picker","text custom colour"]},"value":{"type":"string"}},"additionalProperties":false,"required":["type"]},
          'Brandomatic website fetched': {"type":"object","properties":{"type":{"enum":["loaded","failed"]},"value":{"type":"string"}},"additionalProperties":false,"required":["type","value"]},
          'Bulk Delete Modal Viewed': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Certificate Shared': {"type":"object","properties":{"course_id":{"type":"string"}},"additionalProperties":false,"required":["course_id"]},
          'Certificates Bulk Downloaded': {"type":"object","properties":{"course_id":{"type":"string"},"course_title":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Change Playlist Type': {"type":"object","properties":{"playlist_id":{"type":"string"},"playlist_type":{"enum":["Free","Sequential"]}},"additionalProperties":false,"required":[]},
          'Checklist opened': {"type":"object","properties":{"opened_from":{"type":"string"},"opened_from_page":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Checklist task launched': {"type":"object","properties":{"already_complete":{"type":"boolean"},"task":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Click Card': {"type":"object","properties":{"entity":{"type":"string"},"from":{"type":"string"},"section_index":{"type":"number"},"section_name":{"type":"string"}},"additionalProperties":false,"required":["from"]},
          'Click Create Learner Account Button': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Click Register Here on Login': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Click Sign Up As Individual Learner': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Click Sign Up As Team Trainer': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'click signup button': {"type":"object","properties":{"integration_source":{"type":"string"},"prompt_mode":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Click Take Me Back End Of Sign Up': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Click Take Me Back Start Of Sign Up': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Clicked Connect Integration': {"type":"object","properties":{"integration":{"type":"string"}},"additionalProperties":false,"required":[]},
          'clicked create free account': {"type":"object","properties":{"email":{"type":"string"}},"additionalProperties":false,"required":[]},
          'completed-create-rapid-refresh': {"type":"object","properties":{"isImmediate":{"type":"boolean"},"title":{"type":"string"},"uploadedFile":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Course Certificate Downloaded': {"type":"object","properties":{"course_id":{"type":"string"},"course_title":{"type":"string"},"source":{"enum":["lms","app"]}},"additionalProperties":false,"required":[]},
          'Course Collection Course Moved': {"type":"object","properties":{"course_collection_id":{"type":"string"},"course_id":{"type":"string"}},"additionalProperties":false,"required":["course_collection_id","course_id"]},
          'Course Collection Created': {"type":"object","properties":{"course_collection_id":{"type":"string"}},"additionalProperties":false,"required":["course_collection_id"]},
          'Course Collection Opened': {"type":"object","properties":{"course_collection_id":{"type":"string"}},"additionalProperties":false,"required":["course_collection_id"]},
          'Course Deleted': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Course Edited Anonymously': {"type":"object","properties":{"courseTitle":{"type":"string"},"libraryAuthor":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Course imported from recommended section': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Course Language Switched': {"type":"object","properties":{"isLanguageOriginal":{"type":"boolean"}},"additionalProperties":false,"required":[]},
          'Course Library Course Imported': {"type":"object","properties":{"trigger":{"enum":["card","preview"]},"type":{"enum":["quick-import","import-and-edit"]}},"additionalProperties":false,"required":["trigger","type"]},
          'Course Library Filter Selected': {"type":"object","properties":{"filter_type":{"enum":["featured","accredited"]},"industry":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Course Overview Opened': {"type":"object","properties":{"trigger":{"enum":["course-title","overview-menu"]}},"additionalProperties":false,"required":["trigger"]},
          'Course Preview Lesson Switched': {"type":"object","properties":{"lesson_number":{"type":"integer"}},"additionalProperties":false,"required":[]},
          'Course Preview Tab Clicked': {"type":"object","properties":{"tab_name":{"enum":["preview","details"]}},"additionalProperties":false,"required":["tab_name"]},
          'Course Previewed': {"type":"object","properties":{"course_title":{"type":"string"},"trigger":{"enum":["course-card","course-page","content-library-card"]}},"additionalProperties":false,"required":["course_title","trigger"]},
          'Course Review Comment Added': {"type":"object","properties":{"is_reply":{"type":"boolean"}},"additionalProperties":false,"required":["is_reply"]},
          'Course Review Finished': {"type":"object","properties":{"number_of_invitees":{"type":"integer","minimum":0},"with_message":{"type":"boolean"}},"additionalProperties":false,"required":["number_of_invitees","with_message"]},
          'Course Review Opened': {"type":"object","properties":{"trigger":{"enum":["course page","deeplink","notification centre"]}},"additionalProperties":false,"required":["trigger"]},
          'Course Review Resolved Comment': {"type":"object","properties":{"is_resolved":{"type":"boolean"}},"additionalProperties":false,"required":["is_resolved"]},
          'Course Review Toggled View Resolved Comments': {"type":"object","properties":{"is_visible":{"type":"boolean"}},"additionalProperties":false,"required":["is_visible"]},
          'Course Scheduled': {"type":"object","properties":{"briefcase_count":{"type":"integer","minimum":0},"certificate_type":{"enum":["Customised","Default","Disabled"]},"course_description":{"type":"boolean"},"due_date_applied":{"enum":["No due date","Specific due date"]},"end_date_applied":{"type":"boolean"},"enrollment_type":{"enum":["All users","User groups"]},"external_ID":{"type":"boolean"},"group_training_enabled":{"type":"boolean"},"id":{"pattern":"","type":"string"},"leaderboard_enabled":{"type":"boolean"},"lessons_required":{"enum":["all lessons count equally","specific lessons are required"]},"schedule_status":{"enum":["Now","Later"]},"standard_completion_setting":{"enum":["simple open","standard completion"]},"translations":{"items":{"type":"string"},"type":"array"},"usergroups_enrolled":{"type":"integer"},"users_enrolled":{"type":"integer"}},"additionalProperties":false,"required":["briefcase_count","certificate_type","course_description","group_training_enabled","schedule_status"]},
          'course-completed': {"type":"object","properties":{"appVersion":{"type":"string"},"id":{"pattern":"","type":"string"},"lessonsCompleted":{"type":"number"},"type":{"type":"string"},"value":{"type":"string"}},"additionalProperties":false,"required":[]},
          'course-unlocked': {"type":"object","properties":{"appVersion":{"type":"string"},"id":{"pattern":"","type":"string"},"type":{"type":"string"},"value":{"type":"string"}},"additionalProperties":false,"required":[]},
          'create a course': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'create a lesson': {"type":"object","properties":{"email":{"type":"object"},"type":{"enum":["assessment","conference","course","discussion","lesson","playlist","collection","observation","group-training"]}},"additionalProperties":false,"required":["type"]},
          'Create Course Clicked': {"type":"object","properties":{"trigger":{"enum":["card","header-icon","menu-item","empty-state","empty-state-course-library-search","create-dropdown"]},"type":{"enum":["generate-with-ai","create-blank","convert-a-document-with-ai","convert-a-ppt"]}},"additionalProperties":false,"required":["trigger","type"]},
          'create educateAll account': {"type":"object","properties":{"email":{"type":"string"},"success":{"type":"string"}},"additionalProperties":false,"required":[]},
          'create entreprise account': {"type":"object","properties":{"email":{"type":"string"},"success":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Created Password Manually': {"type":"object","properties":{"update_location":{"enum":["user-profile","create_user","csv","public_api"]}},"additionalProperties":false,"required":["update_location"]},
          'Custom Achievement Archived': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Custom Achievement Created': {"type":"object","properties":{"features":{"items":{"type":"string"},"type":"array"}},"additionalProperties":false,"required":[]},
          'Custom Achievement Deleted': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Custom Achievement Live': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Deeplink Opened': {"type":"object","properties":{"+clicked_branch_link":{"type":"boolean"},"+is_first_session":{"type":"boolean"},"+non_branch_link":{"type":"string"},"+referrer":{"type":"string"},"$canonical_url":{"type":"string"},"$deeplink_path":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Deeplink Used': {"type":"object","properties":{"_i":{"type":"string"},"_p":{"type":"string"},"+click_timestamp":{"type":"string"},"+clicked_branch_link":{"type":"boolean"},"+is_first_session":{"type":"boolean"},"+match_guaranteed":{"type":"string"},"+non_branch_link":{"type":"string"},"+referrer":{"type":"string"},"~creation_source":{"type":"string"},"~id":{"type":"string"},"~referring_link":{"type":"string"},"$android_passive_deepview":{"type":"string"},"$canonical_url":{"type":"string"},"$deeplink_path":{"type":"string"},"$identity_id":{"type":"string"},"$ios_passive_deepview":{"type":"string"},"$matching_ttl_s":{"type":"string"},"$one_time_use":{"type":"string"},"timestamp":{"type":"string"}},"additionalProperties":false,"required":[]},
          'deeplinkCopied': {"type":"object","properties":{"link":{"type":"string"}},"additionalProperties":false,"required":[]},
          'deeplinkDowloaded': {"type":"object","properties":{"link":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Delete Individual Learner': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'deleted-rapid-refresh': {"type":"object","properties":{"email":{"type":"string"},"id":{"pattern":"","type":"string"}},"additionalProperties":false,"required":[]},
          'Disable invite link': {"type":"object","properties":{"group_id":{"type":"string"},"invite_code":{"type":"string"},"invite_link":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Disabled Integration': {"type":"object","properties":{"integration":{"type":"string"}},"additionalProperties":false,"required":[]},
          'document-unlocked': {"type":"object","properties":{"appVersion":{"type":"string"},"id":{"pattern":"","type":"string"},"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'document-viewed': {"type":"object","properties":{"appVersion":{"type":"string"},"id":{"pattern":"","type":"string"},"type":{"type":"string"},"value":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Edapp.com Content Library Searched': {"type":"object","properties":{"search_term":{"type":"string"}},"additionalProperties":false,"required":[]},
          'edit a lesson': {"type":"object","properties":{"course_status":{"type":"string"},"course_title":{"type":"string"},"email":{"pattern":"","type":"string"},"from_library":{"type":"boolean"},"is_uxp":{"type":"boolean"},"itlySchema":{"type":"string"},"itlySource":{"type":"string"},"itlyVersion":{"type":"string"},"lesson_status":{"type":"string"},"lesson_title":{"type":"string"},"slides_changed":{"type":"boolean"},"total_slides":{"type":"integer"},"version_number":{"type":"integer"}},"additionalProperties":false,"required":["course_status","lesson_status","version_number"]},
          'Edit Media File': {"type":"object","properties":{"file_type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Enable invite link': {"type":"object","properties":{"group_id":{"type":"string"},"invite_code":{"type":"string"},"invite_link":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Enter Invite Code On Create Account': {"type":"object","properties":{"code":{"type":"string"},"email":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Existing domain redirect from signup form': {"type":"object","properties":{"email":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Exit mindful learning': {"type":"object","properties":{"actualDurationSeconds":{"type":"number"},"lessonId":{"pattern":"","type":"string"},"postCalm":{"type":"number"},"postFocus":{"type":"number"},"preCalm":{"type":"number"},"preFocus":{"type":"number"},"screen":{"pattern":"","type":"string"},"selectedDurationSeconds":{"type":"number"}},"additionalProperties":false,"required":["actualDurationSeconds","lessonId","postCalm","postFocus","preCalm","preFocus","screen","selectedDurationSeconds"]},
          'Failed Registration': {"type":"object","properties":{"value":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Failed Sign Up Email Exists': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Failed Sign Up SSO': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'failed-login': {"type":"object","properties":{"from":{"type":"string"},"value":{"type":"string"}},"additionalProperties":false,"required":["from"]},
          'Feedback Submitted': {"type":"object","properties":{"comment":{"type":"string"},"course_id":{"type":"string"},"feedback_score":{"enum":["happy","neutral","unhappy"]},"feedback_type":{"type":"string"}},"additionalProperties":false,"required":["course_id","feedback_score","feedback_type"]},
          'File Uploaded': {"type":"object","properties":{"file_size":{"type":"number"},"file_type":{"type":"string"},"location":{"type":"string"},"source":{"enum":["media_library_button","upload_button","drag_n_drop","media_library_drag_n_drop"]},"success":{"type":"boolean"}},"additionalProperties":false,"required":["source","success"]},
          'Go to course page from checklist': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Group Training Learner Self Register': {"type":"object","properties":{"course_id":{"type":"string"},"session_id":{"type":"string"}},"additionalProperties":false,"required":["course_id","session_id"]},
          'Group Training Previewed': {"type":"object","properties":{"course_id":{"type":"string"}},"additionalProperties":false,"required":["course_id"]},
          'Group Training Session Cancelled': {"type":"object","properties":{"course_id":{"type":"string"},"session_id":{"type":"string"},"trigger":{"enum":["group-training-card","session-modal"]}},"additionalProperties":false,"required":["course_id","session_id","trigger"]},
          'Group Training Session Ended': {"type":"object","properties":{"course_id":{"type":"string"},"session_id":{"type":"string"}},"additionalProperties":false,"required":["course_id","session_id"]},
          'Group Training Session Resumed': {"type":"object","properties":{"course_id":{"type":"string"},"session_id":{"type":"string"}},"additionalProperties":false,"required":["course_id","session_id"]},
          'Group Training Session Started': {"type":"object","properties":{"course_id":{"type":"string"},"session_id":{"type":"string"}},"additionalProperties":false,"required":["course_id","session_id"]},
          'Group Training View Report': {"type":"object","properties":{"course_id":{"type":"string"}},"additionalProperties":false,"required":["course_id"]},
          'import a pptx': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Invite Code Edited': {"type":"object","properties":{"group_id":{"type":"string"},"invite_code":{"type":"string"}},"additionalProperties":false,"required":["invite_code"]},
          'Invite code validated on sign up form': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Invite Link Copied': {"type":"object","properties":{"group_id":{"type":"string"},"invite_code":{"type":"string"},"invite_link":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Invite Link QR Code Downloaded': {"type":"object","properties":{"group_id":{"type":"string"},"invite_code":{"type":"string"},"invite_link":{"type":"string"}},"additionalProperties":false,"required":[]},
          'invite users via email': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'invited-user-login': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'leaderboard clicked': {"type":"object","properties":{"type":{"enum":["Course","Group","Individual","RapidRefresher"]}},"additionalProperties":false,"required":["type"]},
          'leaderboard created': {"type":"object","properties":{"type":{"enum":["Group","Individual"]}},"additionalProperties":false,"required":["type"]},
          'leaderboard disabled': {"type":"object","properties":{"type":{"enum":["Rapid Refresh","Course"]}},"additionalProperties":false,"required":["type"]},
          'leaderboard enabled': {"type":"object","properties":{"type":{"enum":["Rapid Refresh","Course"]}},"additionalProperties":false,"required":["type"]},
          'learner filter applied': {"type":"object","properties":{"filters":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Learners App Complete Sign Up': {"type":"object","properties":{"account_type":{"type":"string"},"email":{"type":"string"}},"additionalProperties":false,"required":["account_type"]},
          'Lesson Closed': {"type":"object","properties":{"attempt_id":{"type":"string"},"has_seen_last_slide":{"type":"boolean"},"id":{"pattern":"","type":"string"},"interaction_type":{"enum":["First attempt","Reattempt","View"]},"time_spent":{"type":"number"}},"additionalProperties":false,"required":["interaction_type","time_spent"]},
          'Lesson Downloaded': {"type":"object","properties":{"Course Name":{"type":"string"},"Lesson Name":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Lesson Started': {"type":"object","properties":{"attempt_id":{"type":"string"},"attempt_slide_completed_count":{"type":"integer"},"id":{"pattern":"","type":"string"}},"additionalProperties":false,"required":[]},
          'lesson-completed': {"type":"object","properties":{"appVersion":{"type":"string"},"id":{"pattern":"","type":"string"},"score":{"type":"number"},"type":{"type":"string"},"value":{"type":"string"}},"additionalProperties":false,"required":[]},
          'lesson-unlocked': {"type":"object","properties":{"appVersion":{"type":"string"},"id":{"pattern":"","type":"string"},"type":{"type":"string"},"value":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Library Opened': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Link Copied': {"type":"object","properties":{"link_type":{"enum":["invite","public_course_preview"]}},"additionalProperties":false,"required":["link_type"]},
          'Link Emailed': {"type":"object","properties":{"link_type":{"enum":["course_edit"]}},"additionalProperties":false,"required":["link_type"]},
          'LMS Library Searched': {"type":"object","properties":{"search_term":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Login Redirect To SSO': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'logout': {"type":"object","properties":{"appVersion":{"type":"string"},"type":{"type":"string"},"value":{"type":"string"}},"additionalProperties":false,"required":[]},
          'magic-link-clicked': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'magic-link-sent': {"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Main Login Success': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Mandatory Toggled': {"type":"object","properties":{"course_title":{"type":"string"},"date":{"type":"string"},"enabled":{"type":"boolean"},"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Media Library File Selected': {"type":"object","properties":{"file_type":{"type":"string"},"location":{"type":"string"}},"additionalProperties":false,"required":[]},
          'meeting popup click': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Menu Action Clicked': {"type":"object","properties":{"action":{"enum":["share","edit","give_us_feedback","delete","enable_public_preview_link","disable_public_preview_link","share_with_collaborators","remove_access_to_collaborator"]},"menu_type":{"enum":["course","lesson"]}},"additionalProperties":false,"required":["action","menu_type"]},
          'new-achievement': {"type":"object","properties":{"appVersion":{"type":"string"},"id":{"pattern":"","type":"string"},"type":{"type":"string"},"value":{"type":"string"}},"additionalProperties":false,"required":[]},
          'new-star': {"type":"object","properties":{"appVersion":{"type":"string"},"type":{"enum":["assessment","conference","course","discussion","lesson","playlist","collection","observation","group-training"]},"value":{"type":"string"}},"additionalProperties":false,"required":["type"]},
          'Notification Opened': {"type":"object","properties":{"body":{"type":"string"},"title":{"type":"string"},"topic":{"enum":["AssessmentPostCommentCreated","DiscussionPostCommentCreated","RapidRefreshSessionStarted","SocialLearning","VideoCommentCreated","VideoCreated","BrainBoost","CourseReminder"]},"type":{"type":"string"},"url":{"type":"string"}},"additionalProperties":false,"required":["body","title","topic"]},
          'Observation Created': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Observation Previewed': {"type":"object","properties":{"observation_id":{"type":"string"}},"additionalProperties":false,"required":["observation_id"]},
          'Observation Results Downloaded': {"type":"object","properties":{"observation_id":{"type":"string"}},"additionalProperties":false,"required":["observation_id"]},
          'Observation Submission Completed': {"type":"object","properties":{"observation_id":{"type":"string"},"passed":{"type":"boolean"},"submission_id":{"type":"string"}},"additionalProperties":false,"required":["observation_id","passed","submission_id"]},
          'Observation Submission Resumed': {"type":"object","properties":{"observation_id":{"type":"string"},"submission_id":{"type":"string"}},"additionalProperties":false,"required":["observation_id","submission_id"]},
          'Observation Submission Saved': {"type":"object","properties":{"observation_id":{"type":"string"},"submission_id":{"type":"string"}},"additionalProperties":false,"required":["observation_id","submission_id"]},
          'Observation Submission Started': {"type":"object","properties":{"number_of_attempts":{"type":"number"},"observation_id":{"type":"string"}},"additionalProperties":false,"required":["number_of_attempts","observation_id"]},
          'Observation Submission Submitted': {"type":"object","properties":{"observation_id":{"type":"string"},"submission_id":{"type":"string"}},"additionalProperties":false,"required":["observation_id","submission_id"]},
          'Open mindful learning': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'open-course': {"type":"object","properties":{"appVersion":{"type":"string"},"id":{"pattern":"","type":"string"},"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'open-lesson': {"type":"object","properties":{"appVersion":{"type":"string"},"attempt":{"type":"string"},"courseId":{"type":"string"},"earned_stars":{"type":"number"},"entity":{"type":"string"},"id":{"pattern":"","type":"string"},"interaction_type":{"enum":["First attempt","Reattempt","View"]},"lessonExternalIdentifier":{"type":"string"},"max_stars":{"type":"number"},"needed_score":{"type":"number"},"needed_stars":{"type":"number"},"type":{"enum":["Lesson","Assessment","Discussion","Conference","Observation"]},"value":{"type":"string"}},"additionalProperties":false,"required":["interaction_type"]},
          'open-rapid-refresh': {"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Opened Change Log': {"type":"object","properties":{"type":{"enum":["course","lesson"]}},"additionalProperties":false,"required":["type"]},
          'Opened Course Learner Assignment': {"type":"object","properties":{"trigger":{"enum":["Publish step","Overview page"]}},"additionalProperties":false,"required":[]},
          'Opened Course Translations Dropdown': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Opened Lesson Review Content': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Opened Settings Modal': {"type":"object","properties":{"title":{"type":"string"},"type":{"enum":["assessment","conference","course","discussion","lesson","playlist","collection","observation","group-training"]}},"additionalProperties":false,"required":["type"]},
          'Opened Theme Settings': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'opened-browser': {"type":"object","properties":{"appVersion":{"type":"string"},"type":{"enum":["assessment","conference","course","discussion","lesson","playlist","collection","observation","group-training"]},"value":{"type":"string"}},"additionalProperties":false,"required":["type"]},
          'outbound click register': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Page Size Updated': {"type":"object","properties":{"results_per_page":{"type":"number"}},"additionalProperties":false,"required":[]},
          'Playlist Opened By Learner': {"type":"object","properties":{"playlist_id":{"type":"string"},"playlist_type":{"enum":["Free","Sequential"]}},"additionalProperties":false,"required":[]},
          'Populated Fields on User Profile': {"type":"object","properties":{"fields_assigned":{"items":{"type":"string"},"type":"array"},"update_location":{"enum":["user-profile","create_user","csv","public_api"]},"user_id":{"type":"string"}},"additionalProperties":false,"required":["fields_assigned","update_location","user_id"]},
          'PPT Button Clicked': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'PPT Content Edited': {"type":"object","properties":{"course_id":{"type":"string"},"total_lessons":{"type":"number"},"total_templates_modified":{"type":"integer"}},"additionalProperties":false,"required":[]},
          'PPT conversion form completed': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'PPT file uploaded': {"type":"object","properties":{"file_size":{"type":"number"},"success":{"type":"boolean"}},"additionalProperties":false,"required":["success"]},
          'PPT Immediate Conversion Selected': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'PPT TIYT Conversion Selected': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'privacy-policy-clicked': {"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Prize Draw Finish Create': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Prize Draw Start Create': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Public PPT Choose File Selected': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Public PPT Submitted': {"type":"object","properties":{"file_size":{"type":"number"},"success":{"type":"boolean"}},"additionalProperties":false,"required":["success"]},
          'Public Try Action Clicked': {"type":"object","properties":{"is_edapp":{"type":"boolean"}},"additionalProperties":false,"required":[]},
          'Rapid Refresh Scheduled': {"type":"object","properties":{"end_date":{"type":"string"},"enrollment_type":{"enum":["All users","User groups"]},"id":{"pattern":"","type":"string"},"language":{"type":"string"},"leaderboard_enabled":{"type":"boolean"},"logo_applied":{"type":"boolean"},"name":{"type":"string"},"prerequisites_applied":{"type":"boolean"},"quiz_type":{"enum":["Once","Daily","Weekly"]},"retries_enabled":{"type":"boolean"},"start_date":{"type":"string"},"total_questions":{"type":"number"},"usergroups_enrolled":{"type":"integer"},"users_enrolled":{"type":"integer"}},"additionalProperties":false,"required":[]},
          'rapid-refresh-completed': {"type":"object","properties":{"appVersion":{"type":"string"},"id":{"pattern":"","type":"string"},"lessonsCompleted":{"type":"string"},"type":{"type":"string"},"value":{"type":"string"}},"additionalProperties":false,"required":[]},
          'rapid-refresh-session-completed': {"type":"object","properties":{"appVersion":{"type":"string"},"id":{"pattern":"","type":"string"},"lessonsCompleted":{"type":"number"},"type":{"type":"string"},"value":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Recent Search Item Clicked': {"type":"object","properties":{"text":{"type":"string"}},"additionalProperties":false,"required":[]},
          'register via invite code': {"type":"object","properties":{"appVersion":{"type":"string"},"code":{"type":"string"},"email":{"type":"string"},"userAgent":{"type":"string"},"userId":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Register via invite code failure': {"type":"object","properties":{"code":{"type":"string"},"email":{"type":"string"},"error_code":{"type":"string"}},"additionalProperties":false,"required":["error_code"]},
          'Register Without Email': {"type":"object","properties":{"code":{"type":"string"},"email":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Reset Course Progress': {"type":"object","properties":{"course_id":{"type":"string"},"user_id":{"type":"string"}},"additionalProperties":false,"required":["course_id","user_id"]},
          'reset-course-completion': {"type":"object","properties":{"appVersion":{"type":"string"},"id":{"pattern":"","type":"string"},"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Saved Course Learner Assignment': {"type":"object","properties":{"trigger":{"enum":["Publish step","Overview page"]}},"additionalProperties":false,"required":[]},
          'Search Auto Suggest Item Clicked': {"type":"object","properties":{"description":{"type":"string"},"id":{"pattern":"","type":"string"},"metadata":{"type":"object"},"thumbnail":{"type":"string"},"title":{"type":"string"},"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Search Function Clicked': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Search Result Clicked': {"type":"object","properties":{"description":{"type":"string"},"id":{"pattern":"","type":"string"},"metadata":{"type":"object"},"thumbnail":{"type":"string"},"title":{"type":"string"},"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Search Results Requested': {"type":"object","properties":{"text":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Select see all courses in recommended section': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Settings Changed': {"type":"object","properties":{"courseId":{"type":"string"},"setting":{"enum":["observation_result_access","enable_group_training"]},"type":{"enum":["assessment","conference","course","discussion","lesson","playlist","collection","observation","group-training"]}},"additionalProperties":false,"required":["setting","type"]},
          'Share Action Clicked': {"type":"object","properties":{"action":{"enum":["enable_public_preview_link","disable_public_preview_link","shared_with_collaborators","removed_access_collaborator","qr_code_downloaded","manage_link"]}},"additionalProperties":false,"required":["action"]},
          'Slide AI Create Prompt Generated': {"type":"object","properties":{"ai_slide_type":{"enum":["Questions","Text"]},"topic_input":{"type":"string"}},"additionalProperties":false,"required":["ai_slide_type","topic_input"]},
          'Slide Library - AI Create Opened': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Sort Users Table': {"type":"object","properties":{"column_header":{"type":"string"},"direction":{"enum":["Ascending","Descending"]}},"additionalProperties":false,"required":["column_header","direction"]},
          'spin-and-loose': {"type":"object","properties":{"appVersion":{"type":"string"},"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'spin-and-win': {"type":"object","properties":{"appVersion":{"type":"string"},"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'SSO redirect link on signup form': {"type":"object","properties":{"email":{"type":"string"}},"additionalProperties":false,"required":[]},
          'SSO Redirect Success': {"type":"object","properties":{"company":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Star Bar Open': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Star Bar Play': {"type":"object","properties":{"game":{"enum":["gift_grab","spin_to_win","star_bids","lucky_dip"]}},"additionalProperties":false,"required":["game"]},
          'start-create-rapid-refresh': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'successful-login': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Surveys Filter Applied': {"type":"object","properties":{"filters":{"type":"string"},"searchTerm":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Surveys Search Result Clicked': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'Switched Analytics Report': {"type":"object","properties":{"is_legacy":{"type":"boolean"},"report":{"type":"string"}},"additionalProperties":false,"required":["is_legacy","report"]},
          'tap-locked-course': {"type":"object","properties":{"is_course_seq_playlist":{"type":"boolean"}},"additionalProperties":false,"required":[]},
          'tap-locked-lesson': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'tap-locked-rapid-refresh': {"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'terms-and-conditions-clicked': {"type":"object","properties":{"type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Training Report Exported': {"type":"object","properties":{"course_id":{"type":"string"},"download_time":{"type":"number"},"feature":{"enum":["Group Training","Practical Assessment"]},"id":{"pattern":"","type":"string"},"session_id":{"type":"string"},"type":{"enum":["all","session"]}},"additionalProperties":false,"required":["course_id","download_time","feature","type"]},
          'Translation Action Clicked': {"type":"object","properties":{"action":{"enum":["create-translation","ai-translation","manual-translation","link-translation","unlink-translation","overwrite-content-download","original-language"]},"language":{"type":"string"}},"additionalProperties":false,"required":["action"]},
          'Update Branding': {"type":"object","properties":{"is_uxp":{"type":"boolean"},"itlySchema":{"type":"string"},"itlySource":{"type":"string"},"itlyVersion":{"type":"string"},"level":{"enum":["lesson","course"]},"type":{"items":{"type":"string"},"type":"array"}},"additionalProperties":false,"required":["level","type"]},
          'Update default branding': {"type":"object","properties":{"type":{"enum":["logo","css","background_image","colors"]}},"additionalProperties":false,"required":["type"]},
          'Upgrade to Pro clicked': {"type":"object","properties":{"via_feature":{"enum":["recurring-certification","advanced-certificates"]}},"additionalProperties":false,"required":["via_feature"]},
          'Upload Attempt Over Size Limit': {"type":"object","properties":{"file_size":{"type":"number"},"file_type":{"type":"string"}},"additionalProperties":false,"required":[]},
          'Upload User CSV Clicked': {"type":"object","properties":{"editRoles":{"enum":["add","replace"]},"editUserGroups":{"enum":["replace","add"]},"sendInvitationsEnabled":{"type":"boolean"},"uploadSuccessful":{"type":"boolean"}},"additionalProperties":false,"required":["editRoles","editUserGroups","sendInvitationsEnabled","uploadSuccessful"]},
          'User Deleted': {"type":"object","properties":{"user_id":{"type":"string"}},"additionalProperties":false,"required":["user_id"]},
          'User List Bulk Action Applied': {"type":"object","properties":{"bulk_action_type":{"type":"string"},"users_selected":{"type":"number"}},"additionalProperties":false,"required":["bulk_action_type","users_selected"]},
          'User List Bulk Update Managed User Groups': {"type":"object","properties":{"number_user_groups":{"type":"number"},"update_mode":{"enum":["add","replace"]}},"additionalProperties":false,"required":["number_user_groups","update_mode"]},
          'User List Bulk Update Roles': {"type":"object","properties":{"role_list":{"items":{"type":"string"},"type":"array"},"update_mode":{"enum":["add","replace"]}},"additionalProperties":false,"required":["role_list","update_mode"]},
          'User List Bulk Update User Groups': {"type":"object","properties":{"number_user_groups":{"type":"number"},"update_mode":{"enum":["add","replace"]}},"additionalProperties":false,"required":["number_user_groups","update_mode"]},
          'User List Filters Applied': {"type":"object","properties":{"filter_by_date_registered_end":{"type":"string"},"filter_by_date_registered_start":{"type":"string"},"filter_by_invited":{"items":{"type":"string"},"type":"array"},"filter_by_logged_in":{"items":{"type":"string"},"type":"array"},"filter_by_roles":{"items":{"type":"string"},"type":"array"},"filter_by_user_groups":{"type":"number"},"filter_by_verified":{"items":{"type":"string"},"type":"array"}},"additionalProperties":false,"required":[]},
          'User List Select Users': {"type":"object","properties":{"current_page_number":{"type":"number"},"results_per_page":{"type":"number"},"selection_location":{"enum":["user-list","secondary-search"]},"users_selected":{"type":"number"}},"additionalProperties":false,"required":["selection_location","users_selected"]},
          'User List Viewed Bulk Review Modal': {"type":"object","properties":{"bulk_action_type":{"type":"string"}},"additionalProperties":false,"required":["bulk_action_type"]},
          'User List Viewed Bulk Select Modal': {"type":"object","properties":{"bulk_action_type":{"type":"string"}},"additionalProperties":false,"required":["bulk_action_type"]},
          'User List Viewed Secondary Search Modal': {"type":"object","properties":{"bulk_action_type":{"type":"string"}},"additionalProperties":false,"required":["bulk_action_type"]},
          'User Selects Registration Settings from Invite Users Page': {"type":"object","properties":{},"additionalProperties":false,"required":[]},
          'User Verified': {"type":"object","properties":{"user_id":{"type":"string"}},"additionalProperties":false,"required":["user_id"]},
          'Video Playback Completed': {"type":"object","properties":{"position":{"type":"string"},"title":{"type":"string"},"total_length":{"type":"number"}},"additionalProperties":false,"required":[]},
          'Video Playback Paused': {"type":"object","properties":{"position":{"type":"string"},"title":{"type":"string"},"total_length":{"type":"number"}},"additionalProperties":false,"required":[]},
          'Video Playback Resumed': {"type":"object","properties":{"position":{"type":"string"},"title":{"type":"string"},"total_length":{"type":"number"}},"additionalProperties":false,"required":[]},
          'Video Playback Started': {"type":"object","properties":{"position":{"type":"string"},"title":{"type":"string"},"total_length":{"type":"number"}},"additionalProperties":false,"required":[]},
          'Viewed Course Public Preview': {"type":"object","properties":{"category":{"pattern":"","type":"string"},"is_edapp":{"type":"boolean"},"is_iframe":{"type":"boolean"},"lesson_only":{"type":"boolean"},"name":{"type":"string"},"path":{"pattern":"","type":"string"},"title":{"type":"string"},"url":{"type":"string"}},"additionalProperties":false,"required":["path"]},
          'Viewed User Profile tab': {"type":"object","properties":{"profile_tab_name":{"type":"string"}},"additionalProperties":false,"required":["profile_tab_name"]},
          'Website field populated': {"type":"object","properties":{"type":{"enum":["manually entered","automatically entered","cleared"]},"value":{"type":"string"}},"additionalProperties":false,"required":["type"]},
        }),
        ...destinationPlugins,
        ...plugins,
      ],
    });
  }

  /**
   * Alias a user ID to another user ID.
   * @param userId The user's new ID.
   * @param previousId The user's previous ID.
   * @param options Options for this alias call.
   */
  alias(userId: string, previousId?: string, options?: AliasOptions) {
    this.itly.alias(userId, previousId, options);
  }

  /**
   * Identify a user and set or update that user's properties.
   * @param userId The user's ID.
   * @param properties The user's properties.
   * @param options Options for this identify call.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: IdentifyOptions,
  ) {
    this.itly.identify(userId, properties, options);
  }

  /**
   * Associate the current user with a group and set or update that group's properties.
   * @param groupId The group's ID.
   * @param properties The group's properties.
   * @param options Options for this group call.
   */
  group(
    groupId: string,
    properties?: GroupProperties,
    options?: GroupOptions,
  ) {
    this.itly.group(groupId, properties, options);
  }

  /**
   * Track a page view.
   * @param category The page's category.
   * @param name The page's name.
   * @param properties The page's properties.
   * @param options Options for this page call.
   */
  page(
    category: string,
    name: string,
    properties?: PageProperties,
    options?: PageOptions,
  ) {
    this.itly.page(category, name, properties, options);
  }

  /**
   * T
   *
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  accountSignedUp(
    options?: TrackOptions,
  ) {
    this.itly.track(new AccountSignedUp(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. title)
   * @param options Options for this track call.
   */
  achievementsClicked(
    properties?: AchievementsClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AchievementsClicked(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  achievementsViewed(
    options?: TrackOptions,
  ) {
    this.itly.track(new AchievementsViewed(), options);
  }

  /**
   * Add course to playlist - include property for whether course is sequential or freeform playlist
   *
   * Owner: debbie.cheng@safetyculture.io
   * @param properties The event's properties (e.g. course_ids)
   * @param options Options for this track call.
   */
  addCoursesToPlaylist(
    properties: AddCoursesToPlaylistProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AddCoursesToPlaylist(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. access)
   * @param options Options for this track call.
   */
  adminFilterApplied(
    properties?: AdminFilterAppliedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AdminFilterApplied(properties), options);
  }

  /**
   * Owner: luke.parker@safetyculture.io
   * @param properties The event's properties (e.g. ai_slide_type)
   * @param options Options for this track call.
   */
  aiCreateSlideAddedToLesson(
    properties: AICreateSlideAddedToLessonProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AiCreateSlideAddedToLesson(properties), options);
  }

  /**
   * Event to track when a document is converted using AI Document converter finish the upload and start generating content.
   * @param properties The event's properties (e.g. document_type)
   * @param options Options for this track call.
   */
  aiDocumentConverted(
    properties?: AIDocumentConvertedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AiDocumentConverted(properties), options);
  }

  /**
   * Capture the prompt used for the AI course generation
   *
   * Owner: Firzy
   * @param properties The event's properties (e.g. billing_plan)
   * @param options Options for this track call.
   */
  aiGeneratedCourse(
    properties: AIGeneratedCourseProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AiGeneratedCourse(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. billing_plan)
   * @param options Options for this track call.
   */
  aiGeneratedLesson(
    properties: AIGeneratedLessonProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AiGeneratedLesson(properties), options);
  }

  /**
   * Event to track bulk narration actions triggered by AI in the Learning Management System (LMS).
   * @param options Options for this track call.
   */
  aiNarrationBulkNarrate(
    options?: TrackOptions,
  ) {
    this.itly.track(new AiNarrationBulkNarrate(), options);
  }

  /**
   * Event to track when users select AI narration within the Learning Management System (LMS).
   * @param options Options for this track call.
   */
  aiNarrationSelected(
    options?: TrackOptions,
  ) {
    this.itly.track(new AiNarrationSelected(), options);
  }

  /**
   * Event to track the application of AI narration voice in LMS actions.
   * @param properties The event's properties (e.g. language)
   * @param options Options for this track call.
   */
  aiNarrationVoiceApplied(
    properties: AINarrationVoiceAppliedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AiNarrationVoiceApplied(properties), options);
  }

  /**
   * AIOB -> Rich text editor - > AI Edit
   * @param properties The event's properties (e.g. action)
   * @param options Options for this track call.
   */
  aiTextEdited(
    properties: AITextEditedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AiTextEdited(properties), options);
  }

  /**
   * Action clicked within the AIOB UI
   * @param properties The event's properties (e.g. action)
   * @param options Options for this track call.
   */
  aiobActionClicked(
    properties: AIOBActionClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AiobActionClicked(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. viz_filters_applied)
   * @param options Options for this track call.
   */
  analyticsFilterApplied(
    properties: AnalyticsFilterAppliedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AnalyticsFilterApplied(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  appOpen(
    options?: TrackOptions,
  ) {
    this.itly.track(new AppOpen(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  appUpdateCancelled(
    options?: TrackOptions,
  ) {
    this.itly.track(new AppUpdateCancelled(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  appUpdateClicked(
    options?: TrackOptions,
  ) {
    this.itly.track(new AppUpdateClicked(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  applyCompanyLogoFromChecklist(
    options?: TrackOptions,
  ) {
    this.itly.track(new ApplyCompanyLogoFromChecklist(), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. roles_assigned)
   * @param options Options for this track call.
   */
  assignedRolesToUser(
    properties: AssignedRolesToUserProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AssignedRolesToUser(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. number_groups)
   * @param options Options for this track call.
   */
  assignedUserToGroups(
    properties: AssignedUserToGroupsProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AssignedUserToGroups(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. course_user_group_assign_location)
   * @param options Options for this track call.
   */
  assignedUsersGroupsToCourseLocation(
    properties: AssignedUsersGroupsToCourseLocationProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new AssignedUsersGroupsToCourseLocation(properties), options);
  }

  /**
   * When the admin creates a banner for the very first time.
   *
   * Owner: debbie.cheng@safetyculture.io
   * @param properties The event's properties (e.g. auto_branding)
   * @param options Options for this track call.
   */
  bannerCreated(
    properties?: BannerCreatedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BannerCreated(properties), options);
  }

  /**
   * An admin deletes a banner
   *
   * Owner: debbie.cheng@safetyculture.io
   * @param properties The event's properties (e.g. banner_id)
   * @param options Options for this track call.
   */
  bannerDeleted(
    properties: BannerDeletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BannerDeleted(properties), options);
  }

  /**
   * A learner clicks on a banner in the app
   *
   * Owner: debbie.cheng@safetyculture.io
   * @param properties The event's properties (e.g. banner_id)
   * @param options Options for this track call.
   */
  bannerOpened(
    properties: BannerOpenedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BannerOpened(properties), options);
  }

  /**
   * When the admin updates an existing banner.
   *
   * Owner: debbie.cheng@safetyculture.io
   * @param properties The event's properties (e.g. auto_branding)
   * @param options Options for this track call.
   */
  bannerUpdated(
    properties: BannerUpdatedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BannerUpdated(properties), options);
  }

  /**
   * After clicking “Boost Slides” button only, when clicking to select new courses to enrol, trigger event on save
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. course_count)
   * @param options Options for this track call.
   */
  brainBoostAddCourse(
    properties: BrainBoostAddCourseProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BrainBoostAddCourse(properties), options);
  }

  /**
   * Trigged when a learner clicks Keep Boosting after previous session for the day is completed
   *
   * Owner: alex.swan@safetyculture.io
   * @param options Options for this track call.
   */
  brainBoostContinueSession(
    options?: TrackOptions,
  ) {
    this.itly.track(new BrainBoostContinueSession(), options);
  }

  /**
   * After opening picker from the course card, the course settings, or row in the BB table (when editing slides enrolled for a particular course) trigger event on save.
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  brainBoostEditCourse(
    properties: BrainBoostEditCourseProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BrainBoostEditCourse(properties), options);
  }

  /**
   * When an Admin changes the settings for BB on an account and clicks save
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. slides_per_session)
   * @param options Options for this track call.
   */
  brainBoostEditSettings(
    properties: BrainBoostEditSettingsProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BrainBoostEditSettings(properties), options);
  }

  /**
   * Owner: alex.swan@safetyculture.io
   * @param properties The event's properties (e.g. correct)
   * @param options Options for this track call.
   */
  brainBoostEndSession(
    properties: BrainBoostEndSessionProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BrainBoostEndSession(properties), options);
  }

  /**
   * Trigered when a learner clicks on any of the entry points to open brain boost page
   *
   * Owner: alex.swan@safetyculture.io
   * @param properties The event's properties (e.g. from)
   * @param options Options for this track call.
   */
  brainBoostLearnerOpen(
    properties: BrainBoostLearnerOpenProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BrainBoostLearnerOpen(properties), options);
  }

  /**
   * when the course/slide picker is opened and from where
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  brainBoostOpenPicker(
    properties: BrainBoostOpenPickerProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BrainBoostOpenPicker(properties), options);
  }

  /**
   * Trigger event after clicking the trash icon next to a course in the BB table and clicking to confirm
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  brainBoostRemoveCourse(
    properties: BrainBoostRemoveCourseProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BrainBoostRemoveCourse(properties), options);
  }

  /**
   * Owner: Romain Guillaume
   * @param properties The event's properties (e.g. session_count)
   * @param options Options for this track call.
   */
  brainBoostStartSession(
    properties: BrainBoostStartSessionProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BrainBoostStartSession(properties), options);
  }

  /**
   * The website field was populated during Signup and the user clicked Edit design
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  brandomaticEditLogoOrColours(
    properties: BrandomaticEditLogoOrColoursProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BrandomaticEditLogoOrColours(properties), options);
  }

  /**
   * Tracks whether Brandomatic is successful or fails to load the website.
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  brandomaticWebsiteFetched(
    properties: BrandomaticWebsiteFetchedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new BrandomaticWebsiteFetched(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param options Options for this track call.
   */
  bulkDeleteModalViewed(
    options?: TrackOptions,
  ) {
    this.itly.track(new BulkDeleteModalViewed(), options);
  }

  /**
   * Tracking learner shares of certificates to socials
   *
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  certificateShared(
    properties: CertificateSharedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CertificateShared(properties), options);
  }

  /**
   * To track when admins request to bulk download certificates for a course. This can be triggered from two places in App settings (from the course list page or from the course).
   *
   * Owner: giustina.booth@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  certificatesBulkDownloaded(
    properties?: CertificatesBulkDownloadedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CertificatesBulkDownloaded(properties), options);
  }

  /**
   * Change playlist settings to sequential / to free form
   *
   * Owner: debbie.cheng@safetyculture.io
   * @param properties The event's properties (e.g. playlist_id)
   * @param options Options for this track call.
   */
  changePlaylistType(
    properties?: ChangePlaylistTypeProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ChangePlaylistType(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. opened_from)
   * @param options Options for this track call.
   */
  checklistOpened(
    properties?: ChecklistOpenedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ChecklistOpened(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. already_complete)
   * @param options Options for this track call.
   */
  checklistTaskLaunched(
    properties?: ChecklistTaskLaunchedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ChecklistTaskLaunched(properties), options);
  }

  /**
   * If learner clicks on a card in the home screen.
   *
   * Owner: Igor Motta
   * @param properties The event's properties (e.g. entity)
   * @param options Options for this track call.
   */
  clickCard(
    properties: ClickCardProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ClickCard(properties), options);
  }

  /**
   * On learners app, click to create account
   *
   * Owner: alex.swan@safetyculture.io
   * @param options Options for this track call.
   */
  clickCreateLearnerAccountButton(
    options?: TrackOptions,
  ) {
    this.itly.track(new ClickCreateLearnerAccountButton(), options);
  }

  /**
   * Clicks on `Have an invite code? Register here` link
   *
   * Owner: debbie.cheng@safetyculture.io
   * @param options Options for this track call.
   */
  clickRegisterHereOnLogin(
    options?: TrackOptions,
  ) {
    this.itly.track(new ClickRegisterHereOnLogin(), options);
  }

  /**
   * Start of IL sign up flow
   *
   * Owner: alex.swan@safetyculture.io
   * @param options Options for this track call.
   */
  clickSignUpAsIndividualLearner(
    options?: TrackOptions,
  ) {
    this.itly.track(new ClickSignUpAsIndividualLearner(), options);
  }

  /**
   * Start of TT sign up flow
   *
   * Owner: alex.swan@safetyculture.io
   * @param options Options for this track call.
   */
  clickSignUpAsTeamTrainer(
    options?: TrackOptions,
  ) {
    this.itly.track(new ClickSignUpAsTeamTrainer(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. integration_source)
   * @param options Options for this track call.
   */
  clickSignupButton(
    properties?: ClickSignupButtonProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ClickSignupButton(properties), options);
  }

  /**
   * Owner: alex.swan@safetyculture.io
   * @param options Options for this track call.
   */
  clickTakeMeBackEndOfSignUp(
    options?: TrackOptions,
  ) {
    this.itly.track(new ClickTakeMeBackEndOfSignUp(), options);
  }

  /**
   * Owner: alex.swan@safetyculture.io
   * @param options Options for this track call.
   */
  clickTakeMeBackStartOfSignUp(
    options?: TrackOptions,
  ) {
    this.itly.track(new ClickTakeMeBackStartOfSignUp(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. integration)
   * @param options Options for this track call.
   */
  clickedConnectIntegration(
    properties?: ClickedConnectIntegrationProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ClickedConnectIntegration(properties), options);
  }

  /**
   * Old Signup form in jade
   *
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. email)
   * @param options Options for this track call.
   */
  clickedCreateFreeAccount(
    properties?: ClickedCreateFreeAccountProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ClickedCreateFreeAccount(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. isImmediate)
   * @param options Options for this track call.
   */
  completedCreateRapidRefresh(
    properties?: CompletedCreateRapidRefreshProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CompletedCreateRapidRefresh(properties), options);
  }

  /**
   * To track when an individual course certificate is downloaded
   *
   * Owner: giustina.booth@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  courseCertificateDownloaded(
    properties?: CourseCertificateDownloadedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseCertificateDownloaded(properties), options);
  }

  /**
   * This event tracks when a course is moved into to a course collection
   * @param properties The event's properties (e.g. course_collection_id)
   * @param options Options for this track call.
   */
  courseCollectionCourseMoved(
    properties: CourseCollectionCourseMovedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseCollectionCourseMoved(properties), options);
  }

  /**
   * This event is triggered when a new course collection is created in the LMS
   * @param properties The event's properties (e.g. course_collection_id)
   * @param options Options for this track call.
   */
  courseCollectionCreated(
    properties: CourseCollectionCreatedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseCollectionCreated(properties), options);
  }

  /**
   * Tracks when a user opens a course collection in the learner app
   * @param properties The event's properties (e.g. course_collection_id)
   * @param options Options for this track call.
   */
  courseCollectionOpened(
    properties: CourseCollectionOpenedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseCollectionOpened(properties), options);
  }

  /**
   * This event tracks when a course is deleted in the Learning Management System (LMS)
   * @param options Options for this track call.
   */
  courseDeleted(
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseDeleted(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. courseTitle)
   * @param options Options for this track call.
   */
  courseEditedAnonymously(
    properties?: CourseEditedAnonymouslyProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseEditedAnonymously(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  courseImportedFromRecommendedSection(
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseImportedFromRecommendedSection(), options);
  }

  /**
   * Event to track when a user switches the language of a course in the LX.
   * @param properties The event's properties (e.g. isLanguageOriginal)
   * @param options Options for this track call.
   */
  courseLanguageSwitched(
    properties?: CourseLanguageSwitchedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseLanguageSwitched(properties), options);
  }

  /**
   * Event to track when a course is imported from the course library
   * @param properties The event's properties (e.g. trigger)
   * @param options Options for this track call.
   */
  courseLibraryCourseImported(
    properties: CourseLibraryCourseImportedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseLibraryCourseImported(properties), options);
  }

  /**
   * Event to track when a user selects a filter in the course library within the Learning Management System (LMS)
   * @param properties The event's properties (e.g. filter_type)
   * @param options Options for this track call.
   */
  courseLibraryFilterSelected(
    properties?: CourseLibraryFilterSelectedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseLibraryFilterSelected(properties), options);
  }

  /**
   * Event Description:  This event is triggered when a user opens the course overview modal
   * @param properties The event's properties (e.g. trigger)
   * @param options Options for this track call.
   */
  courseOverviewOpened(
    properties: CourseOverviewOpenedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseOverviewOpened(properties), options);
  }

  /**
   * Event that captures when a user switches between lessons during a course preview
   * @param properties The event's properties (e.g. lesson_number)
   * @param options Options for this track call.
   */
  coursePreviewLessonSwitched(
    properties?: CoursePreviewLessonSwitchedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CoursePreviewLessonSwitched(properties), options);
  }

  /**
   * Event to track when users click on the course preview tab
   * @param properties The event's properties (e.g. tab_name)
   * @param options Options for this track call.
   */
  coursePreviewTabClicked(
    properties: CoursePreviewTabClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CoursePreviewTabClicked(properties), options);
  }

  /**
   * Event is triggered when a user clicks 'preview' from:
   *
   * * course-card on courseware page
   *
   * * course-page
   *
   * * content-library-card
   *
   * Owner: Romain Guillaume
   * @param properties The event's properties (e.g. course_title)
   * @param options Options for this track call.
   */
  coursePreviewed(
    properties: CoursePreviewedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CoursePreviewed(properties), options);
  }

  /**
   * User posted a comment or/and reply
   *
   * Owner: Gianfranco
   * @param properties The event's properties (e.g. is_reply)
   * @param options Options for this track call.
   */
  courseReviewCommentAdded(
    properties: CourseReviewCommentAddedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseReviewCommentAdded(properties), options);
  }

  /**
   * Reviewer by clicking `I'm done` button
   *
   * Owner: Gianfranco
   * @param properties The event's properties (e.g. number_of_invitees)
   * @param options Options for this track call.
   */
  courseReviewFinished(
    properties: CourseReviewFinishedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseReviewFinished(properties), options);
  }

  /**
   * User has navigated to the course review page, either via Review in LMS or via email/ direct link
   *
   * Owner: Gianfranco
   * @param properties The event's properties (e.g. trigger)
   * @param options Options for this track call.
   */
  courseReviewOpened(
    properties: CourseReviewOpenedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseReviewOpened(properties), options);
  }

  /**
   * reviewer resolved a comment
   *
   * Owner: Gianfranco
   * @param properties The event's properties (e.g. is_resolved)
   * @param options Options for this track call.
   */
  courseReviewResolvedComment(
    properties: CourseReviewResolvedCommentProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseReviewResolvedComment(properties), options);
  }

  /**
   * Reviewer click hide/resolved comments view
   *
   * Owner: Gianfranco
   * @param properties The event's properties (e.g. is_visible)
   * @param options Options for this track call.
   */
  courseReviewToggledViewResolvedComments(
    properties: CourseReviewToggledViewResolvedCommentsProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseReviewToggledViewResolvedComments(properties), options);
  }

  /**
   * To track when a user schedules a course
   *
   * Owner: giustina.booth@safetyculture.io
   * @param properties The event's properties (e.g. briefcase_count)
   * @param options Options for this track call.
   */
  courseScheduled(
    properties: CourseScheduledProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseScheduled(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  courseCompleted(
    properties?: CourseCompletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseCompleted(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  courseUnlocked(
    properties?: CourseUnlockedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CourseUnlocked(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  createACourse(
    options?: TrackOptions,
  ) {
    this.itly.track(new CreateACourse(), options);
  }

  /**
   *
   *
   *
   *
   * Triggered when a user clicks create a lesson and selects a lesson type.
   *
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. email)
   * @param options Options for this track call.
   */
  createALesson(
    properties: CreateALessonProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CreateALesson(properties), options);
  }

  /**
   * Create course event triggered from different trigger
   * @param properties The event's properties (e.g. trigger)
   * @param options Options for this track call.
   */
  createCourseClicked(
    properties: CreateCourseClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CreateCourseClicked(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. email)
   * @param options Options for this track call.
   */
  createEducateAllAccount(
    properties?: CreateEducateAllAccountProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CreateEducateAllAccount(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. email)
   * @param options Options for this track call.
   */
  createEntrepriseAccount(
    properties?: CreateEntrepriseAccountProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CreateEntrepriseAccount(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. update_location)
   * @param options Options for this track call.
   */
  createdPasswordManually(
    properties: CreatedPasswordManuallyProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CreatedPasswordManually(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  customAchievementArchived(
    options?: TrackOptions,
  ) {
    this.itly.track(new CustomAchievementArchived(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. features)
   * @param options Options for this track call.
   */
  customAchievementCreated(
    properties?: CustomAchievementCreatedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new CustomAchievementCreated(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  customAchievementDeleted(
    options?: TrackOptions,
  ) {
    this.itly.track(new CustomAchievementDeleted(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  customAchievementLive(
    options?: TrackOptions,
  ) {
    this.itly.track(new CustomAchievementLive(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. +clicked_branch_link)
   * @param options Options for this track call.
   */
  deeplinkOpened(
    properties?: DeeplinkOpenedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new DeeplinkOpened(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. _i)
   * @param options Options for this track call.
   */
  deeplinkUsed(
    properties?: DeeplinkUsedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new DeeplinkUsed(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. link)
   * @param options Options for this track call.
   */
  deeplinkCopied(
    properties?: DeeplinkCopiedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new DeeplinkCopied(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. link)
   * @param options Options for this track call.
   */
  deeplinkDowloaded(
    properties?: DeeplinkDowloadedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new DeeplinkDowloaded(properties), options);
  }

  /**
   * When an IL confirms deletion of their account
   *
   * Owner: debbie.cheng@safetyculture.io
   * @param options Options for this track call.
   */
  deleteIndividualLearner(
    options?: TrackOptions,
  ) {
    this.itly.track(new DeleteIndividualLearner(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. email)
   * @param options Options for this track call.
   */
  deletedRapidRefresh(
    properties?: DeletedRapidRefreshProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new DeletedRapidRefresh(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. group_id)
   * @param options Options for this track call.
   */
  disableInviteLink(
    properties?: DisableInviteLinkProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new DisableInviteLink(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. integration)
   * @param options Options for this track call.
   */
  disabledIntegration(
    properties?: DisabledIntegrationProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new DisabledIntegration(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  documentUnlocked(
    properties?: DocumentUnlockedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new DocumentUnlocked(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  documentViewed(
    properties?: DocumentViewedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new DocumentViewed(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. search_term)
   * @param options Options for this track call.
   */
  edappComContentLibrarySearched(
    properties?: EdappComContentLibrarySearchedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new EdappComContentLibrarySearched(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. course_status)
   * @param options Options for this track call.
   */
  editALesson(
    properties: EditALessonProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new EditALesson(properties), options);
  }

  /**
   * Owner: Florencia Rojas
   * @param properties The event's properties (e.g. file_type)
   * @param options Options for this track call.
   */
  editMediaFile(
    properties?: EditMediaFileProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new EditMediaFile(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. group_id)
   * @param options Options for this track call.
   */
  enableInviteLink(
    properties?: EnableInviteLinkProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new EnableInviteLink(properties), options);
  }

  /**
   * Learner enters email and Invite code, then clicks next successfully
   *
   * Owner: alex.swan@safetyculture.io
   * @param properties The event's properties (e.g. code)
   * @param options Options for this track call.
   */
  enterInviteCodeOnCreateAccount(
    properties?: EnterInviteCodeOnCreateAccountProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new EnterInviteCodeOnCreateAccount(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. email)
   * @param options Options for this track call.
   */
  existingDomainRedirectFromSignupForm(
    properties?: ExistingDomainRedirectFromSignupFormProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ExistingDomainRedirectFromSignupForm(properties), options);
  }

  /**
   * Owner: Romain Guillaume
   * @param properties The event's properties (e.g. actualDurationSeconds)
   * @param options Options for this track call.
   */
  exitMindfulLearning(
    properties: ExitMindfulLearningProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ExitMindfulLearning(properties), options);
  }

  /**
   * When a learner attempts to sign up via the registration page and does not succeed
   *
   * Owner: alex.swan@safetyculture.io
   * @param properties The event's properties (e.g. value)
   * @param options Options for this track call.
   */
  failedRegistration(
    properties?: FailedRegistrationProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new FailedRegistration(properties), options);
  }

  /**
   * Learner attempts to sign up with email that already exists in system
   *
   * Owner: alex.swan@safetyculture.io
   * @param options Options for this track call.
   */
  failedSignUpEmailExists(
    options?: TrackOptions,
  ) {
    this.itly.track(new FailedSignUpEmailExists(), options);
  }

  /**
   * Learner attempts too sign up but has SSO domain
   *
   * Owner: alex.swan@safetyculture.io
   * @param options Options for this track call.
   */
  failedSignUpSso(
    options?: TrackOptions,
  ) {
    this.itly.track(new FailedSignUpSso(), options);
  }

  /**
   * Login failure, from either `#login` or email invite
   *
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. from)
   * @param options Options for this track call.
   */
  failedLogin(
    properties: FailedLoginProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new FailedLogin(properties), options);
  }

  /**
   * Event triggered when a user answer the feedback form
   *
   *
   *
   *
   * @param properties The event's properties (e.g. comment)
   * @param options Options for this track call.
   */
  feedbackSubmitted(
    properties: FeedbackSubmittedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new FeedbackSubmitted(properties), options);
  }

  /**
   * When a file is added to Media Library, either automatically when adding a file to any upload field or by accessing the Media Library directly and selecting 'Add to Library'
   *
   * * type of media
   *
   * * which upload field
   *
   * Owner: Florencia Rojas
   * @param properties The event's properties (e.g. file_size)
   * @param options Options for this track call.
   */
  fileUploaded(
    properties: FileUploadedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new FileUploaded(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  goToCoursePageFromChecklist(
    options?: TrackOptions,
  ) {
    this.itly.track(new GoToCoursePageFromChecklist(), options);
  }

  /**
   * Learner registering to a group Training session via QR code
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  groupTrainingLearnerSelfRegister(
    properties: GroupTrainingLearnerSelfRegisterProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new GroupTrainingLearnerSelfRegister(properties), options);
  }

  /**
   * Click Preview
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  groupTrainingPreviewed(
    properties: GroupTrainingPreviewedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new GroupTrainingPreviewed(properties), options);
  }

  /**
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  groupTrainingSessionCancelled(
    properties: GroupTrainingSessionCancelledProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new GroupTrainingSessionCancelled(properties), options);
  }

  /**
   * Click End Session
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  groupTrainingSessionEnded(
    properties: GroupTrainingSessionEndedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new GroupTrainingSessionEnded(properties), options);
  }

  /**
   * Click Resume Session
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  groupTrainingSessionResumed(
    properties: GroupTrainingSessionResumedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new GroupTrainingSessionResumed(properties), options);
  }

  /**
   * Click on Start Session
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  groupTrainingSessionStarted(
    properties: GroupTrainingSessionStartedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new GroupTrainingSessionStarted(properties), options);
  }

  /**
   * Click View Course Report
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  groupTrainingViewReport(
    properties: GroupTrainingViewReportProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new GroupTrainingViewReport(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  importAPptx(
    options?: TrackOptions,
  ) {
    this.itly.track(new ImportAPptx(), options);
  }

  /**
   * Owner: Romain Guillaume
   * @param properties The event's properties (e.g. group_id)
   * @param options Options for this track call.
   */
  inviteCodeEdited(
    properties: InviteCodeEditedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new InviteCodeEdited(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  inviteCodeValidatedOnSignUpForm(
    options?: TrackOptions,
  ) {
    this.itly.track(new InviteCodeValidatedOnSignUpForm(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. group_id)
   * @param options Options for this track call.
   */
  inviteLinkCopied(
    properties?: InviteLinkCopiedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new InviteLinkCopied(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. group_id)
   * @param options Options for this track call.
   */
  inviteLinkQrCodeDownloaded(
    properties?: InviteLinkQRCodeDownloadedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new InviteLinkQrCodeDownloaded(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  inviteUsersViaEmail(
    options?: TrackOptions,
  ) {
    this.itly.track(new InviteUsersViaEmail(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  invitedUserLogin(
    options?: TrackOptions,
  ) {
    this.itly.track(new InvitedUserLogin(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  leaderboardClicked(
    properties: LeaderboardClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LeaderboardClicked(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  leaderboardCreated(
    properties: LeaderboardCreatedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LeaderboardCreated(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  leaderboardDisabled(
    properties: LeaderboardDisabledProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LeaderboardDisabled(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  leaderboardEnabled(
    properties: LeaderboardEnabledProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LeaderboardEnabled(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. filters)
   * @param options Options for this track call.
   */
  learnerFilterApplied(
    properties?: LearnerFilterAppliedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LearnerFilterApplied(properties), options);
  }

  /**
   * Successfully signs up in app as Individual Learner or Team Trainer
   *
   * Owner: alex.swan@safetyculture.io
   * @param properties The event's properties (e.g. account_type)
   * @param options Options for this track call.
   */
  learnersAppCompleteSignUp(
    properties: LearnersAppCompleteSignUpProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LearnersAppCompleteSignUp(properties), options);
  }

  /**
   * Owner: Igor Motta
   * @param properties The event's properties (e.g. attempt_id)
   * @param options Options for this track call.
   */
  lessonClosed(
    properties: LessonClosedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LessonClosed(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. Course Name)
   * @param options Options for this track call.
   */
  lessonDownloaded(
    properties?: LessonDownloadedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LessonDownloaded(properties), options);
  }

  /**
   * When a learner click start a lesson
   *
   * Owner: Romain Guillaume
   * @param properties The event's properties (e.g. attempt_id)
   * @param options Options for this track call.
   */
  lessonStarted(
    properties?: LessonStartedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LessonStarted(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  lessonCompleted(
    properties?: LessonCompletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LessonCompleted(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  lessonUnlocked(
    properties?: LessonUnlockedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LessonUnlocked(properties), options);
  }

  /**
   * Content Library Opened
   *
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  libraryOpened(
    options?: TrackOptions,
  ) {
    this.itly.track(new LibraryOpened(), options);
  }

  /**
   * This event tracks when a user copies a link within the LMS platform
   * @param properties The event's properties (e.g. link_type)
   * @param options Options for this track call.
   */
  linkCopied(
    properties: LinkCopiedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LinkCopied(properties), options);
  }

  /**
   * This event tracks when a link is emailed within the Learning Management System (LMS) Actions
   * @param properties The event's properties (e.g. link_type)
   * @param options Options for this track call.
   */
  linkEmailed(
    properties: LinkEmailedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LinkEmailed(properties), options);
  }

  /**
   * Content Library Searched
   *
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. search_term)
   * @param options Options for this track call.
   */
  lmsLibrarySearched(
    properties?: LMSLibrarySearchedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new LmsLibrarySearched(properties), options);
  }

  /**
   * Learner attempts log in and is redirected to SSO login
   *
   * Owner: alex.swan@safetyculture.io
   * @param options Options for this track call.
   */
  loginRedirectToSso(
    options?: TrackOptions,
  ) {
    this.itly.track(new LoginRedirectToSso(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  logout(
    properties?: LogoutProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new Logout(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  magicLinkClicked(
    options?: TrackOptions,
  ) {
    this.itly.track(new MagicLinkClicked(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  magicLinkSent(
    properties?: MagicLinkSentProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new MagicLinkSent(properties), options);
  }

  /**
   * User logs in successfully from `#login`
   *
   * Owner: debbie.cheng@safetyculture.io
   * @param options Options for this track call.
   */
  mainLoginSuccess(
    options?: TrackOptions,
  ) {
    this.itly.track(new MainLoginSuccess(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. course_title)
   * @param options Options for this track call.
   */
  mandatoryToggled(
    properties?: MandatoryToggledProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new MandatoryToggled(properties), options);
  }

  /**
   * When a user selects the media Library button from an upload field.
   *
   * * type of media
   *
   * * location
   *
   * Owner: Florencia Rojas
   * @param properties The event's properties (e.g. file_type)
   * @param options Options for this track call.
   */
  mediaLibraryFileSelected(
    properties?: MediaLibraryFileSelectedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new MediaLibraryFileSelected(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  meetingPopupClick(
    options?: TrackOptions,
  ) {
    this.itly.track(new MeetingPopupClick(), options);
  }

  /**
   * This event tracks when a user clicks on a menu action within the Learning Management System (LMS)
   * @param properties The event's properties (e.g. action)
   * @param options Options for this track call.
   */
  menuActionClicked(
    properties: MenuActionClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new MenuActionClicked(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  newAchievement(
    properties?: NewAchievementProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new NewAchievement(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  newStar(
    properties: NewStarProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new NewStar(properties), options);
  }

  /**
   * Triggered when notification clicked
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. body)
   * @param options Options for this track call.
   */
  notificationOpened(
    properties: NotificationOpenedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new NotificationOpened(properties), options);
  }

  /**
   * When a new lesson, type practical assessment, has been created.
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param options Options for this track call.
   */
  observationCreated(
    options?: TrackOptions,
  ) {
    this.itly.track(new ObservationCreated(), options);
  }

  /**
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. observation_id)
   * @param options Options for this track call.
   */
  observationPreviewed(
    properties: ObservationPreviewedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ObservationPreviewed(properties), options);
  }

  /**
   * Event that tracks when learners view their full observation results
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. observation_id)
   * @param options Options for this track call.
   */
  observationResultsDownloaded(
    properties: ObservationResultsDownloadedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ObservationResultsDownloaded(properties), options);
  }

  /**
   * When a practical assessment has been finished and submitted as passed
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. observation_id)
   * @param options Options for this track call.
   */
  observationSubmissionCompleted(
    properties: ObservationSubmissionCompletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ObservationSubmissionCompleted(properties), options);
  }

  /**
   * When a facilitator selects to "Resume practical assessment"
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. observation_id)
   * @param options Options for this track call.
   */
  observationSubmissionResumed(
    properties: ObservationSubmissionResumedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ObservationSubmissionResumed(properties), options);
  }

  /**
   * When a practical assessment has commnced and the facilitator selects to "Save and Exit"
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. observation_id)
   * @param options Options for this track call.
   */
  observationSubmissionSaved(
    properties: ObservationSubmissionSavedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ObservationSubmissionSaved(properties), options);
  }

  /**
   * When a facilitator selects "Start Practical Assessment"
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. number_of_attempts)
   * @param options Options for this track call.
   */
  observationSubmissionStarted(
    properties: ObservationSubmissionStartedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ObservationSubmissionStarted(properties), options);
  }

  /**
   * When a practical assessment has been finished and submitted. (Passed and Failed)
   *
   * Owner: Jacqueline Lee
   * @param properties The event's properties (e.g. observation_id)
   * @param options Options for this track call.
   */
  observationSubmissionSubmitted(
    properties: ObservationSubmissionSubmittedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ObservationSubmissionSubmitted(properties), options);
  }

  /**
   * Owner: Romain Guillaume
   * @param options Options for this track call.
   */
  openMindfulLearning(
    options?: TrackOptions,
  ) {
    this.itly.track(new OpenMindfulLearning(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  openCourse(
    properties?: OpenCourseProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new OpenCourse(properties), options);
  }

  /**
   * Event to track when a user opens a lesson within the LX
   *
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  openLesson(
    properties: OpenLessonProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new OpenLesson(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  openRapidRefresh(
    properties?: OpenRapidRefreshProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new OpenRapidRefresh(properties), options);
  }

  /**
   * Owner: Romain Guillaume
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  openedChangeLog(
    properties: OpenedChangeLogProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new OpenedChangeLog(properties), options);
  }

  /**
   * This fires when an admin clicks on "assign" button to assign a course from anywhere in Edapp or SafetyCulture Training.
   *
   * Owner: Romain Guillaume
   * @param properties The event's properties (e.g. trigger)
   * @param options Options for this track call.
   */
  openedCourseLearnerAssignment(
    properties?: OpenedCourseLearnerAssignmentProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new OpenedCourseLearnerAssignment(properties), options);
  }

  /**
   * Owner: Romain Guillaume
   * @param options Options for this track call.
   */
  openedCourseTranslationsDropdown(
    options?: TrackOptions,
  ) {
    this.itly.track(new OpenedCourseTranslationsDropdown(), options);
  }

  /**
   * Owner: Romain Guillaume
   * @param options Options for this track call.
   */
  openedLessonReviewContent(
    options?: TrackOptions,
  ) {
    this.itly.track(new OpenedLessonReviewContent(), options);
  }

  /**
   * Owner: Romain Guillaume
   * @param properties The event's properties (e.g. title)
   * @param options Options for this track call.
   */
  openedSettingsModal(
    properties: OpenedSettingsModalProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new OpenedSettingsModal(properties), options);
  }

  /**
   * Owner: anthony.drury@safetyculture.io
   * @param options Options for this track call.
   */
  openedThemeSettings(
    options?: TrackOptions,
  ) {
    this.itly.track(new OpenedThemeSettings(), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  openedBrowser(
    properties: OpenedBrowserProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new OpenedBrowser(properties), options);
  }

  /**
   * Summit Page
   *
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  outboundClickRegister(
    options?: TrackOptions,
  ) {
    this.itly.track(new OutboundClickRegister(), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. results_per_page)
   * @param options Options for this track call.
   */
  pageSizeUpdated(
    properties?: PageSizeUpdatedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PageSizeUpdated(properties), options);
  }

  /**
   * Learner opens playlist - include property for whether it is sequential or free form
   *
   * Owner: debbie.cheng@safetyculture.io
   * @param properties The event's properties (e.g. playlist_id)
   * @param options Options for this track call.
   */
  playlistOpenedByLearner(
    properties?: PlaylistOpenedByLearnerProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PlaylistOpenedByLearner(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. fields_assigned)
   * @param options Options for this track call.
   */
  populatedFieldsOnUserProfile(
    properties: PopulatedFieldsOnUserProfileProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PopulatedFieldsOnUserProfile(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  pptButtonClicked(
    options?: TrackOptions,
  ) {
    this.itly.track(new PptButtonClicked(), options);
  }

  /**
   * To track when a user clicks "Step 2 - Edit content" from the PPT conversion tool available in the LMS. It excludes when users click this from the public PPT conversion tool. ![]()
   *
   * Owner: giustina.booth@safetyculture.io
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  pptContentEdited(
    properties?: PPTContentEditedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PptContentEdited(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  pptConversionFormCompleted(
    options?: TrackOptions,
  ) {
    this.itly.track(new PptConversionFormCompleted(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. file_size)
   * @param options Options for this track call.
   */
  pptFileUploaded(
    properties: PPTFileUploadedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PptFileUploaded(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  pptImmediateConversionSelected(
    options?: TrackOptions,
  ) {
    this.itly.track(new PptImmediateConversionSelected(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  ppttiytConversionSelected(
    options?: TrackOptions,
  ) {
    this.itly.track(new PpttiytConversionSelected(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  privacyPolicyClicked(
    properties?: PrivacyPolicyClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PrivacyPolicyClicked(properties), options);
  }

  /**
   * This event tracks when an admin finishes creating a prize draw.
   * @param options Options for this track call.
   */
  prizeDrawFinishCreate(
    options?: TrackOptions,
  ) {
    this.itly.track(new PrizeDrawFinishCreate(), options);
  }

  /**
   * This event tracks when an admin clicks "create a draw" within the LMS.
   * @param options Options for this track call.
   */
  prizeDrawStartCreate(
    options?: TrackOptions,
  ) {
    this.itly.track(new PrizeDrawStartCreate(), options);
  }

  /**
   * Owner: Romain Guillaume
   * @param options Options for this track call.
   */
  publicPptChooseFileSelected(
    options?: TrackOptions,
  ) {
    this.itly.track(new PublicPptChooseFileSelected(), options);
  }

  /**
   * Owner: Romain Guillaume
   * @param properties The event's properties (e.g. file_size)
   * @param options Options for this track call.
   */
  publicPptSubmitted(
    properties: PublicPPTSubmittedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PublicPptSubmitted(properties), options);
  }

  /**
   * This event is triggered when a user clicks on the "Try EdApp" or "Try SafetyCulture" action
   * @param properties The event's properties (e.g. is_edapp)
   * @param options Options for this track call.
   */
  publicTryActionClicked(
    properties?: PublicTryActionClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new PublicTryActionClicked(properties), options);
  }

  /**
   * To track when a user schedules a rapid refresh quiz
   *
   * Owner: Giustina Salvestro-Booth
   * @param properties The event's properties (e.g. end_date)
   * @param options Options for this track call.
   */
  rapidRefreshScheduled(
    properties?: RapidRefreshScheduledProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new RapidRefreshScheduled(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  rapidRefreshCompleted(
    properties?: RapidRefreshCompletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new RapidRefreshCompleted(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  rapidRefreshSessionCompleted(
    properties?: RapidRefreshSessionCompletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new RapidRefreshSessionCompleted(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. text)
   * @param options Options for this track call.
   */
  recentSearchItemClicked(
    properties?: RecentSearchItemClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new RecentSearchItemClicked(properties), options);
  }

  /**
   * User successfully registers with invite code
   *
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  registerViaInviteCode(
    properties?: RegisterViaInviteCodeProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new RegisterViaInviteCode(properties), options);
  }

  /**
   * Owner: debbie.cheng@safetyculture.io
   * @param properties The event's properties (e.g. code)
   * @param options Options for this track call.
   */
  registerViaInviteCodeFailure(
    properties: RegisterViaInviteCodeFailureProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new RegisterViaInviteCodeFailure(properties), options);
  }

  /**
   * Owner: Igor Motta
   * @param properties The event's properties (e.g. code)
   * @param options Options for this track call.
   */
  registerWithoutEmail(
    properties?: RegisterWithoutEmailProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new RegisterWithoutEmail(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  resetCourseProgress(
    properties: ResetCourseProgressProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ResetCourseProgress(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  resetCourseCompletion(
    properties?: ResetCourseCompletionProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ResetCourseCompletion(properties), options);
  }

  /**
   * This fires when an admin clicks on the "save" button when assigning a course from anywhere in Edapp or SafetyCulture Training.
   * @param properties The event's properties (e.g. trigger)
   * @param options Options for this track call.
   */
  savedCourseLearnerAssignment(
    properties?: SavedCourseLearnerAssignmentProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SavedCourseLearnerAssignment(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. description)
   * @param options Options for this track call.
   */
  searchAutoSuggestItemClicked(
    properties?: SearchAutoSuggestItemClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SearchAutoSuggestItemClicked(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  searchFunctionClicked(
    options?: TrackOptions,
  ) {
    this.itly.track(new SearchFunctionClicked(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. description)
   * @param options Options for this track call.
   */
  searchResultClicked(
    properties?: SearchResultClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SearchResultClicked(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. text)
   * @param options Options for this track call.
   */
  searchResultsRequested(
    properties?: SearchResultsRequestedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SearchResultsRequested(properties), options);
  }

  /**
   * Content Library Select see all courses in recommended section
   *
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  selectSeeAllCoursesInRecommendedSection(
    options?: TrackOptions,
  ) {
    this.itly.track(new SelectSeeAllCoursesInRecommendedSection(), options);
  }

  /**
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. courseId)
   * @param options Options for this track call.
   */
  settingsChanged(
    properties: SettingsChangedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SettingsChanged(properties), options);
  }

  /**
   * This event tracks when a user clicks on the "Share" action within the Learning Management System (LMS)
   * @param properties The event's properties (e.g. action)
   * @param options Options for this track call.
   */
  shareActionClicked(
    properties: ShareActionClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ShareActionClicked(properties), options);
  }

  /**
   * Owner: luke.parker@safetyculture.io
   * @param properties The event's properties (e.g. ai_slide_type)
   * @param options Options for this track call.
   */
  slideAiCreatePromptGenerated(
    properties: SlideAICreatePromptGeneratedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SlideAiCreatePromptGenerated(properties), options);
  }

  /**
   * Owner: luke.parker@safetyculture.io
   * @param options Options for this track call.
   */
  slideLibraryAiCreateOpened(
    options?: TrackOptions,
  ) {
    this.itly.track(new SlideLibraryAiCreateOpened(), options);
  }

  /**
   * Owner: Jane Fan
   * @param properties The event's properties (e.g. column_header)
   * @param options Options for this track call.
   */
  sortUsersTable(
    properties: SortUsersTableProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SortUsersTable(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  spinAndLoose(
    properties?: SpinAndLooseProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SpinAndLoose(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. appVersion)
   * @param options Options for this track call.
   */
  spinAndWin(
    properties?: SpinAndWinProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SpinAndWin(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. email)
   * @param options Options for this track call.
   */
  ssoRedirectLinkOnSignupForm(
    properties?: SSORedirectLinkOnSignupFormProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SsoRedirectLinkOnSignupForm(properties), options);
  }

  /**
   * User is successfully redirected to company sign on when they use SSO Login
   *
   * Owner: debbie.cheng@safetyculture.io
   * @param properties The event's properties (e.g. company)
   * @param options Options for this track call.
   */
  ssoRedirectSuccess(
    properties?: SSORedirectSuccessProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SsoRedirectSuccess(properties), options);
  }

  /**
   * This event tracks when the Star Bar is opened by a learner from the learner profile.
   * @param options Options for this track call.
   */
  starBarOpen(
    options?: TrackOptions,
  ) {
    this.itly.track(new StarBarOpen(), options);
  }

  /**
   * This event tracks when a learner plays a prizing game
   * @param properties The event's properties (e.g. game)
   * @param options Options for this track call.
   */
  starBarPlay(
    properties: StarBarPlayProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new StarBarPlay(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  startCreateRapidRefresh(
    options?: TrackOptions,
  ) {
    this.itly.track(new StartCreateRapidRefresh(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  successfulLogin(
    options?: TrackOptions,
  ) {
    this.itly.track(new SuccessfulLogin(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. filters)
   * @param options Options for this track call.
   */
  surveysFilterApplied(
    properties?: SurveysFilterAppliedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SurveysFilterApplied(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  surveysSearchResultClicked(
    options?: TrackOptions,
  ) {
    this.itly.track(new SurveysSearchResultClicked(), options);
  }

  /**
   * Owner: Jacqueline Lee
   * @param properties The event's properties (e.g. is_legacy)
   * @param options Options for this track call.
   */
  switchedAnalyticsReport(
    properties: SwitchedAnalyticsReportProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new SwitchedAnalyticsReport(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. is_course_seq_playlist)
   * @param options Options for this track call.
   */
  tapLockedCourse(
    properties?: TapLockedCourseProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new TapLockedCourse(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  tapLockedLesson(
    options?: TrackOptions,
  ) {
    this.itly.track(new TapLockedLesson(), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  tapLockedRapidRefresh(
    properties?: TapLockedRapidRefreshProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new TapLockedRapidRefresh(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  termsAndConditionsClicked(
    properties?: TermsAndConditionsClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new TermsAndConditionsClicked(properties), options);
  }

  /**
   * Tracks when a training report is exported.
   * @param properties The event's properties (e.g. course_id)
   * @param options Options for this track call.
   */
  trainingReportExported(
    properties: TrainingReportExportedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new TrainingReportExported(properties), options);
  }

  /**
   * Actions a user can do with the translation fThis event tracks when a user clicks on a translation actioneature
   * @param properties The event's properties (e.g. action)
   * @param options Options for this track call.
   */
  translationActionClicked(
    properties: TranslationActionClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new TranslationActionClicked(properties), options);
  }

  /**
   * Owner: anthony.drury@safetyculture.io
   * @param properties The event's properties (e.g. is_uxp)
   * @param options Options for this track call.
   */
  updateBranding(
    properties: UpdateBrandingProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UpdateBranding(properties), options);
  }

  /**
   * Owner: Esteban Rodriguez
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  updateDefaultBranding(
    properties: UpdateDefaultBrandingProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UpdateDefaultBranding(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. via_feature)
   * @param options Options for this track call.
   */
  upgradeToProClicked(
    properties: UpgradeToProClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UpgradeToProClicked(properties), options);
  }

  /**
   * Owner: Florencia Rojas
   * @param properties The event's properties (e.g. file_size)
   * @param options Options for this track call.
   */
  uploadAttemptOverSizeLimit(
    properties?: UploadAttemptOverSizeLimitProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UploadAttemptOverSizeLimit(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. editRoles)
   * @param options Options for this track call.
   */
  uploadUserCsvClicked(
    properties: UploadUserCSVClickedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UploadUserCsvClicked(properties), options);
  }

  /**
   * Owner: Jane Fan
   * @param properties The event's properties (e.g. user_id)
   * @param options Options for this track call.
   */
  userDeleted(
    properties: UserDeletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UserDeleted(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. bulk_action_type)
   * @param options Options for this track call.
   */
  userListBulkActionApplied(
    properties: UserListBulkActionAppliedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UserListBulkActionApplied(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. number_user_groups)
   * @param options Options for this track call.
   */
  userListBulkUpdateManagedUserGroups(
    properties: UserListBulkUpdateManagedUserGroupsProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UserListBulkUpdateManagedUserGroups(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. role_list)
   * @param options Options for this track call.
   */
  userListBulkUpdateRoles(
    properties: UserListBulkUpdateRolesProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UserListBulkUpdateRoles(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. number_user_groups)
   * @param options Options for this track call.
   */
  userListBulkUpdateUserGroups(
    properties: UserListBulkUpdateUserGroupsProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UserListBulkUpdateUserGroups(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. filter_by_date_registered_end)
   * @param options Options for this track call.
   */
  userListFiltersApplied(
    properties?: UserListFiltersAppliedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UserListFiltersApplied(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. current_page_number)
   * @param options Options for this track call.
   */
  userListSelectUsers(
    properties: UserListSelectUsersProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UserListSelectUsers(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. bulk_action_type)
   * @param options Options for this track call.
   */
  userListViewedBulkReviewModal(
    properties: UserListViewedBulkReviewModalProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UserListViewedBulkReviewModal(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. bulk_action_type)
   * @param options Options for this track call.
   */
  userListViewedBulkSelectModal(
    properties: UserListViewedBulkSelectModalProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UserListViewedBulkSelectModal(properties), options);
  }

  /**
   * Owner: Cecilia Adelstein
   * @param properties The event's properties (e.g. bulk_action_type)
   * @param options Options for this track call.
   */
  userListViewedSecondarySearchModal(
    properties: UserListViewedSecondarySearchModalProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UserListViewedSecondarySearchModal(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param options Options for this track call.
   */
  userSelectsRegistrationSettingsFromInviteUsersPage(
    options?: TrackOptions,
  ) {
    this.itly.track(new UserSelectsRegistrationSettingsFromInviteUsersPage(), options);
  }

  /**
   * Owner: Jane Fan
   * @param properties The event's properties (e.g. user_id)
   * @param options Options for this track call.
   */
  userVerified(
    properties: UserVerifiedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new UserVerified(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. position)
   * @param options Options for this track call.
   */
  videoPlaybackCompleted(
    properties?: VideoPlaybackCompletedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new VideoPlaybackCompleted(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. position)
   * @param options Options for this track call.
   */
  videoPlaybackPaused(
    properties?: VideoPlaybackPausedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new VideoPlaybackPaused(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. position)
   * @param options Options for this track call.
   */
  videoPlaybackResumed(
    properties?: VideoPlaybackResumedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new VideoPlaybackResumed(properties), options);
  }

  /**
   * Owner: alexandra@edapp.com
   * @param properties The event's properties (e.g. position)
   * @param options Options for this track call.
   */
  videoPlaybackStarted(
    properties?: VideoPlaybackStartedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new VideoPlaybackStarted(properties), options);
  }

  /**
   * This event tracks when a user views the public preview of a course.
   * @param properties The event's properties (e.g. category)
   * @param options Options for this track call.
   */
  viewedCoursePublicPreview(
    properties: ViewedCoursePublicPreviewProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ViewedCoursePublicPreview(properties), options);
  }

  /**
Event has no description in tracking plan.
   * @param properties The event's properties (e.g. profile_tab_name)
   * @param options Options for this track call.
   */
  viewedUserProfileTab(
    properties: ViewedUserProfileTabProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new ViewedUserProfileTab(properties), options);
  }

  /**
   * The website field in Signup was populated
   *
   * Owner: leanne.huynh@safetyculture.io
   * @param properties The event's properties (e.g. type)
   * @param options Options for this track call.
   */
  websiteFieldPopulated(
    properties: WebsiteFieldPopulatedProperties,
    options?: TrackOptions,
  ) {
    this.itly.track(new WebsiteFieldPopulated(properties), options);
  }

  /**
   * Track any event.
   * @param event The event to track.
   * @param options Options for this track call.
   */
  track(event: Event, options?: TrackOptions) {
    this.itly.track(event, options);
  }

  /**
   * Reset (e.g. on logout) all analytics state for the current user and group.
   */
  reset() {
    this.itly.reset();
  }

  async flush() {
    await this.itly.flush();
  }
}

export default new Itly();
